// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg width=%273%27 height=%273%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m 0 3 L 3 3 L 3 0 C 3 1 1 3 0 3%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg width=%273%27 height=%273%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m 0 3 L 1 3 L 3 3 C 2 3 0 1 0 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 stroke=%27%23000%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cstyle%3E.spinner_V8m1%7Btransform-origin:center;animation:spinner_zKoa 2s linear infinite%7D.spinner_V8m1 circle%7Bstroke-linecap:round;animation:spinner_YpZS 1.5s ease-out infinite%7D%40keyframes spinner_zKoa%7B100%25%7Btransform:rotate%28360deg%29%7D%7D%40keyframes spinner_YpZS%7B0%25%7Bstroke-dasharray:0 150;stroke-dashoffset:0%7D47.5%25%7Bstroke-dasharray:42 150;stroke-dashoffset:-16%7D95%25%2C100%25%7Bstroke-dasharray:42 150;stroke-dashoffset:-59%7D%7D%3C%2Fstyle%3E%3Cg class=%27spinner_V8m1%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279.5%27 fill=%27none%27 stroke-width=%273%27%3E%3C%2Fcircle%3E%3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cstyle%3E.spinner_qM83%7Banimation:spinner_8HQG 1.05s infinite%7D.spinner_oXPr%7Banimation-delay:.1s%7D.spinner_ZTLf%7Banimation-delay:.2s%7D@keyframes spinner_8HQG%7B0%25,57.14%25%7Banimation-timing-function:cubic-bezier%280.33,.66,.66,1%29;transform:translate%280%29%7D28.57%25%7Banimation-timing-function:cubic-bezier%280.33,0,.66,.33%29;transform:translateY%28-6px%29%7D100%25%7Btransform:translate%280%29%7D%7D%3C/style%3E%3Ccircle class=%27spinner_qM83%27 cx=%274%27 cy=%2712%27 r=%273%27/%3E%3Ccircle class=%27spinner_qM83 spinner_oXPr%27 cx=%2712%27 cy=%2712%27 r=%273%27/%3E%3Ccircle class=%27spinner_qM83 spinner_ZTLf%27 cx=%2720%27 cy=%2712%27 r=%273%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg width=%2744%27 height=%2744%27 viewBox=%270 0 44 44%27 xmlns=%27http://www.w3.org/2000/svg%27 stroke=%27%23fff%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27 stroke-width=%272%27%3E%3Ccircle cx=%2722%27 cy=%2722%27 r=%271%27%3E%3Canimate attributeName=%27r%27 begin=%270s%27 dur=%271.8s%27 values=%271; 20%27 calcMode=%27spline%27 keyTimes=%270; 1%27 keySplines=%270.165, 0.84, 0.44, 1%27 repeatCount=%27indefinite%27 /%3E%3Canimate attributeName=%27stroke-opacity%27 begin=%270s%27 dur=%271.8s%27 values=%271; 0%27 calcMode=%27spline%27 keyTimes=%270; 1%27 keySplines=%270.3, 0.61, 0.355, 1%27 repeatCount=%27indefinite%27 /%3E%3C/circle%3E%3Ccircle cx=%2722%27 cy=%2722%27 r=%271%27%3E%3Canimate attributeName=%27r%27 begin=%27-0.9s%27 dur=%271.8s%27 values=%271; 20%27 calcMode=%27spline%27 keyTimes=%270; 1%27 keySplines=%270.165, 0.84, 0.44, 1%27 repeatCount=%27indefinite%27 /%3E%3Canimate attributeName=%27stroke-opacity%27 begin=%27-0.9s%27 dur=%271.8s%27 values=%271; 0%27 calcMode=%27spline%27 keyTimes=%270; 1%27 keySplines=%270.3, 0.61, 0.355, 1%27 repeatCount=%27indefinite%27 /%3E%3C/circle%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%0A%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cstyle%3E.spinner_rXNP%7Banimation:spinner_YeBj .8s infinite%7D@keyframes spinner_YeBj%7B0%25%7Banimation-timing-function:cubic-bezier%280.33,0,.66,.33%29;cy:5px%7D46.875%25%7Bcy:20px;rx:4px;ry:4px%7D50%25%7Banimation-timing-function:cubic-bezier%280.33,.66,.66,1%29;cy:20.5px;rx:4.8px;ry:3px%7D53.125%25%7Brx:4px;ry:4px%7D100%25%7Bcy:5px%7D%7D%3C/style%3E%3Cellipse class=%27spinner_rXNP%27 cx=%2712%27 cy=%275%27 rx=%274%27 ry=%274%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%0A%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cstyle%3E.spinner_hzlK%7Banimation:spinner_vc4H .8s linear infinite;animation-delay:-.8s%7D.spinner_koGT%7Banimation-delay:-.65s%7D.spinner_YF1u%7Banimation-delay:-.5s%7D@keyframes spinner_vc4H%7B0%25%7By:1px;height:22px%7D93.75%25%7By:5px;height:14px;opacity:.2%7D%7D%3C/style%3E%3Crect class=%27spinner_hzlK%27 x=%271%27 y=%271%27 width=%276%27 height=%2722%27/%3E%3Crect class=%27spinner_hzlK spinner_koGT%27 x=%279%27 y=%271%27 width=%276%27 height=%2722%27/%3E%3Crect class=%27spinner_hzlK spinner_YF1u%27 x=%2717%27 y=%271%27 width=%276%27 height=%2722%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 style=%27shape-rendering: auto;%27 width=%27200px%27 height=%27200px%27 viewBox=%270 0 100 100%27 preserveAspectRatio=%27xMidYMid%27%3E%3Cpath fill=%27none%27 stroke=%27%230a0a0a%27 stroke-width=%2710%27 stroke-dasharray=%27205.271142578125 51.317785644531256%27 d=%27M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z%27 stroke-linecap=%27round%27 style=%27transform:scale%280.8%29;transform-origin:50px 50px%27%3E%3Canimate attributeName=%27stroke-dashoffset%27 repeatCount=%27indefinite%27 dur=%272s%27 keyTimes=%270;1%27 values=%270;256.58892822265625%27%3E%3C/animate%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27200%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M100 0C20 0 0 20 0 100s20 100 100 100 100-20 100-100S180 0 100 0Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg width=%27192%27 height=%27200%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m96 0 58.779 19.098 36.327 50v61.804l-36.327 50L96 200l-58.779-19.098-36.327-50V69.098l36.327-50z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27200%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m100 0 100 100-100 100L0 100z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27185%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M100 184.606a15.384 15.384 0 0 1-8.653-2.678C53.565 156.28 37.205 138.695 28.182 127.7 8.952 104.264-.254 80.202.005 54.146.308 24.287 24.264 0 53.406 0c21.192 0 35.869 11.937 44.416 21.879a2.884 2.884 0 0 0 4.356 0C110.725 11.927 125.402 0 146.594 0c29.142 0 53.098 24.287 53.4 54.151.26 26.061-8.956 50.122-28.176 73.554-9.023 10.994-25.383 28.58-63.165 54.228a15.384 15.384 0 0 1-8.653 2.673Z%27 fill=%27black%27 fill-rule=%27nonzero%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg width=%27182%27 height=%27201%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M.3 65.486c0-9.196 6.687-20.063 14.211-25.078l61.86-35.946c8.36-5.016 20.899-5.016 29.258 0l61.86 35.946c8.36 5.015 14.211 15.882 14.211 25.078v71.055c0 9.196-6.687 20.063-14.211 25.079l-61.86 35.945c-8.36 4.18-20.899 4.18-29.258 0L14.51 161.62C6.151 157.44.3 145.737.3 136.54V65.486Z%27 fill=%27black%27 fill-rule=%27nonzero%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27182%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M64.786 181.4c-9.196 0-20.063-6.687-25.079-14.21L3.762 105.33c-5.016-8.36-5.016-20.9 0-29.259l35.945-61.86C44.723 5.851 55.59 0 64.786 0h71.055c9.196 0 20.063 6.688 25.079 14.211l35.945 61.86c4.18 8.36 4.18 20.899 0 29.258l-35.945 61.86c-4.18 8.36-15.883 14.211-25.079 14.211H64.786Z%27 fill=%27black%27 fill-rule=%27nonzero%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27200%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle fill=%27black%27 cx=%27100%27 cy=%27100%27 r=%27100%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27154%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M46.154 0H200l-46.154 153.846H0z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27154%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M153.846 0H0l46.154 153.846H200z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg width=%27154%27 height=%27201%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M.077 47.077v153.846l153.846-46.154V.923z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg width=%27154%27 height=%27201%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M153.923 47.077v153.846L.077 154.77V.923z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg width=%27192%27 height=%27181%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m96 0 95.106 69.098-36.327 111.804H37.22L.894 69.098z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg width=%27200%27 height=%27200%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M0 0h200v200H0z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg width=%27192%27 height=%27180%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m96 137.263-58.779 42.024 22.163-68.389L.894 68.481l72.476-.243L96 0l22.63 68.238 72.476.243-58.49 42.417 22.163 68.389z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg width=%27192%27 height=%27180%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m96 153.044-58.779 26.243 7.02-63.513L.894 68.481l63.117-13.01L96 0l31.989 55.472 63.117 13.01-43.347 47.292 7.02 63.513z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg width=%27174%27 height=%27149%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m87 148.476-86.603.185L43.86 74.423 87 0l43.14 74.423 43.463 74.238z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg width=%27174%27 height=%27150%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m87 .738 86.603-.184-43.463 74.238L87 149.214 43.86 74.792.397.554z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg width=%27150%27 height=%27174%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27m149.369 87.107.185 86.603-74.239-43.463L.893 87.107l74.422-43.14L149.554.505z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg width=%27150%27 height=%27174%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill=%27black%27 d=%27M.631 87.107.446.505l74.239 43.462 74.422 43.14-74.422 43.14L.446 173.71z%27 fill-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=PT+Sans+Caption:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=PT+Sans+Caption:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Work+Sans:400,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

:root,
[data-theme]{
  background-color: hsl(var(--b1) / var(--tw-bg-opacity, 1));
  color: hsl(var(--bc) / var(--tw-text-opacity, 1));
}

html{
  -webkit-tap-highlight-color: transparent;
}

:root{
  color-scheme: light;
  --pf: 259 94% 44%;
  --sf: 314 100% 40%;
  --af: 174 75% 39%;
  --nf: 214 20% 14%;
  --in: 198 93% 60%;
  --su: 158 64% 52%;
  --wa: 43 96% 56%;
  --er: 0 91% 71%;
  --inc: 198 100% 12%;
  --suc: 158 100% 10%;
  --wac: 43 100% 11%;
  --erc: 0 100% 14%;
  --rounded-box: 1rem;
  --rounded-btn: 0.5rem;
  --rounded-badge: 1.9rem;
  --animation-btn: 0.25s;
  --animation-input: .2s;
  --btn-text-case: uppercase;
  --btn-focus-scale: 0.95;
  --border-btn: 1px;
  --tab-border: 1px;
  --tab-radius: 0.5rem;
  --p: 259 94% 51%;
  --pc: 259 96% 91%;
  --s: 314 100% 47%;
  --sc: 314 100% 91%;
  --a: 174 75% 46%;
  --ac: 174 75% 11%;
  --n: 214 20% 21%;
  --nc: 212 19% 87%;
  --b1: 0 0% 100%;
  --b2: 0 0% 95%;
  --b3: 180 2% 90%;
  --bc: 215 28% 17%;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container{
  width: 100%;
}
@media (min-width: 320px){

  .container{
    max-width: 320px;
  }
}
@media (min-width: 375px){

  .container{
    max-width: 375px;
  }
}
@media (min-width: 425px){

  .container{
    max-width: 425px;
  }
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 864px){

  .container{
    max-width: 864px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1366px){

  .container{
    max-width: 1366px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
@media (min-width: 1920px){

  .container{
    max-width: 1920px;
  }
}
@media (min-width: 2560px){

  .container{
    max-width: 2560px;
  }
}
.alert{
  display: grid;
  width: 100%;
  grid-auto-flow: row;
  align-content: flex-start;
  align-items: center;
  justify-items: center;
  gap: 1rem;
  text-align: center;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  padding: 1rem;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  border-radius: var(--rounded-box, 1rem);
  --alert-bg: hsl(var(--b2));
  --alert-bg-mix: hsl(var(--b1));
  background-color: var(--alert-bg);
}
@media (min-width: 640px){

  .alert{
    grid-auto-flow: column;
    grid-template-columns: auto minmax(auto,1fr);
    justify-items: start;
    text-align: left;
  }
}
.artboard{
  width: 100%;
}
.avatar{
  position: relative;
  display: inline-flex;
}
.avatar > div{
  display: block;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}
.avatar img{
  height: 100%;
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
.avatar.placeholder > div{
  display: flex;
  align-items: center;
  justify-content: center;
}
.badge{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  height: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 0.563rem;
  padding-right: 0.563rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  border-radius: var(--rounded-badge, 1.9rem);
}
.btm-nav{
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-bottom: env(safe-area-inset-bottom);
  height: 4rem;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  color: currentColor;
}
.btm-nav > *{
  position: relative;
  display: flex;
  height: 100%;
  flex-basis: 100%;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border-color: currentColor;
}
.breadcrumbs{
  max-width: 100%;
  overflow-x: auto;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.breadcrumbs > ul,
  .breadcrumbs > ol{
  display: flex;
  align-items: center;
  white-space: nowrap;
  min-height: -moz-min-content;
  min-height: min-content;
}
.breadcrumbs > ul > li, .breadcrumbs > ol > li{
  display: flex;
  align-items: center;
}
.breadcrumbs > ul > li > a, .breadcrumbs > ol > li > a{
  display: flex;
  cursor: pointer;
  align-items: center;
}
@media (hover:hover){

  .breadcrumbs > ul > li > a:hover, .breadcrumbs > ol > li > a:hover{
    text-decoration-line: underline;
  }

  .link-hover:hover{
    text-decoration-line: underline;
  }

  .checkbox-primary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--p) / var(--tw-border-opacity));
  }

  .checkbox-secondary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--s) / var(--tw-border-opacity));
  }

  .checkbox-accent:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--a) / var(--tw-border-opacity));
  }

  .checkbox-success:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--su) / var(--tw-border-opacity));
  }

  .checkbox-warning:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--wa) / var(--tw-border-opacity));
  }

  .checkbox-info:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--in) / var(--tw-border-opacity));
  }

  .checkbox-error:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--er) / var(--tw-border-opacity));
  }

  .label a:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--bc) / var(--tw-text-opacity));
  }

  .link-primary:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--pf) / var(--tw-text-opacity));
  }

  .link-secondary:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--sf) / var(--tw-text-opacity));
  }

  .link-accent:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--af) / var(--tw-text-opacity));
  }

  .link-neutral:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--nf) / var(--tw-text-opacity));
  }

  .link-success:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--su) / var(--tw-text-opacity));
  }

  .link-info:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--in) / var(--tw-text-opacity));
  }

  .link-warning:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--wa) / var(--tw-text-opacity));
  }

  .link-error:hover{
    --tw-text-opacity: 1;
    color: hsl(var(--er) / var(--tw-text-opacity));
  }

  .menu li > *:not(ul):not(.menu-title):not(details):active,
.menu li > *:not(ul):not(.menu-title):not(details).active,
.menu li > details > summary:active{
    --tw-bg-opacity: 1;
    background-color: hsl(var(--n) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--nc) / var(--tw-text-opacity));
  }

  .radio-primary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--p) / var(--tw-border-opacity));
  }

  .radio-secondary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--s) / var(--tw-border-opacity));
  }

  .radio-accent:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--a) / var(--tw-border-opacity));
  }

  .radio-success:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--su) / var(--tw-border-opacity));
  }

  .radio-warning:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--wa) / var(--tw-border-opacity));
  }

  .radio-info:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--in) / var(--tw-border-opacity));
  }

  .radio-error:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--er) / var(--tw-border-opacity));
  }

  .tab:hover{
    --tw-text-opacity: 1;
  }

  .tabs-boxed .tab-active:not(.tab-disabled):not([disabled]):hover{
    --tw-text-opacity: 1;
    color: hsl(var(--pc) / var(--tw-text-opacity));
  }

  .table tr.hover:hover,
  .table tr.hover:nth-child(even):hover{
    --tw-bg-opacity: 1;
    background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  }

  .table-zebra tr.hover:hover,
  .table-zebra tr.hover:nth-child(even):hover{
    --tw-bg-opacity: 1;
    background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  }
}
.btn{
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-color: transparent;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  text-align: center;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  border-radius: var(--rounded-btn, 0.5rem);
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  min-height: 3rem;
  font-size: 0.875rem;
  line-height: 1em;
  gap: 0.5rem;
  font-weight: 600;
  text-decoration-line: none;
  border-width: var(--border-btn, 1px);
  animation: button-pop var(--animation-btn, 0.25s) ease-out;
  text-transform: var(--btn-text-case, uppercase);
  --tw-border-opacity: 1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  outline-color: hsl(var(--bc) / 1);
}
.btn-disabled,
  .btn[disabled],
  .btn:disabled{
  pointer-events: none;
}
.btn-square{
  height: 3rem;
  width: 3rem;
  padding: 0px;
}
.btn-circle{
  height: 3rem;
  width: 3rem;
  border-radius: 9999px;
  padding: 0px;
}
.btn-group{
  display: inline-flex;
}
.btn-group > input[type="radio"].btn{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.btn-group > input[type="radio"].btn:before{
  content: attr(data-title);
}
.btn:is(input[type="checkbox"]),
.btn:is(input[type="radio"]){
  width: auto;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.btn:is(input[type="checkbox"]):after,
.btn:is(input[type="radio"]):after{
  --tw-content: attr(aria-label);
  content: var(--tw-content);
}
.card{
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: var(--rounded-box, 1rem);
}
.card:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.card-body{
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: var(--padding-card, 2rem);
  gap: 0.5rem;
}
.card-body :where(p){
  flex-grow: 1;
}
.card-actions{
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem;
}
.card figure{
  display: flex;
  align-items: center;
  justify-content: center;
}
.card.image-full{
  display: grid;
}
.card.image-full:before{
  position: relative;
  content: "";
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  opacity: 0.75;
  border-radius: var(--rounded-box, 1rem);
}
.card.image-full:before,
    .card.image-full > *{
  grid-column-start: 1;
  grid-row-start: 1;
}
.card.image-full > figure img{
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
.card.image-full > .card-body{
  position: relative;
  z-index: 20;
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
}
.carousel{
  display: inline-flex;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.carousel-vertical{
  flex-direction: column;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
}
.carousel-item{
  box-sizing: content-box;
  display: flex;
  flex: none;
  scroll-snap-align: start;
}
.carousel-center .carousel-item{
  scroll-snap-align: center;
}
.carousel-end .carousel-item{
  scroll-snap-align: end;
}
.chat{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.chat-image{
  grid-row: span 2 / span 2;
  align-self: flex-end;
}
.chat-header{
  grid-row-start: 1;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.chat-footer{
  grid-row-start: 3;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.chat-bubble{
  position: relative;
  display: block;
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  max-width: 90%;
  border-radius: var(--rounded-box, 1rem);
  min-height: 2.75rem;
  min-width: 2.75rem;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
}
.chat-bubble:before{
  position: absolute;
  bottom: 0px;
  height: 0.75rem;
  width: 0.75rem;
  background-color: inherit;
  content: "";
  -webkit-mask-size: contain;
          mask-size: contain;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
}
.chat-start{
  place-items: start;
  grid-template-columns: auto 1fr;
}
.chat-start .chat-header{
  grid-column-start: 2;
}
.chat-start .chat-footer{
  grid-column-start: 2;
}
.chat-start .chat-image{
  grid-column-start: 1;
}
.chat-start .chat-bubble{
  grid-column-start: 2;
  border-bottom-left-radius: 0px;
}
.chat-start .chat-bubble:before{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  left: -0.749rem;
}
[dir="rtl"] .chat-start .chat-bubble:before{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.chat-end{
  place-items: end;
  grid-template-columns: 1fr auto;
}
.chat-end .chat-header{
  grid-column-start: 1;
}
.chat-end .chat-footer{
  grid-column-start: 1;
}
.chat-end .chat-image{
  grid-column-start: 2;
}
.chat-end .chat-bubble{
  grid-column-start: 1;
  border-bottom-right-radius: 0px;
}
.chat-end .chat-bubble:before{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  left: 99.9%;
}
[dir="rtl"] .chat-end .chat-bubble:before{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.\\!checkbox{
  flex-shrink: 0 !important;
  --chkbg: var(--bc) !important;
  --chkfg: var(--b1) !important;
  height: 1.5rem !important;
  width: 1.5rem !important;
  cursor: pointer !important;
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
  border-width: 1px !important;
  border-color: hsl(var(--bc) / var(--tw-border-opacity)) !important;
  --tw-border-opacity: 0.2 !important;
  border-radius: var(--rounded-btn, 0.5rem) !important;
}
.checkbox{
  flex-shrink: 0;
  --chkbg: var(--bc);
  --chkfg: var(--b1);
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
  border-radius: var(--rounded-btn, 0.5rem);
}
.collapse:not(td):not(tr):not(colgroup){
  visibility: visible;
}
.collapse{
  position: relative;
  display: grid;
  overflow: hidden;
  grid-template-rows: auto 0fr;
  transition: grid-template-rows 0.2s;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
}
.collapse-title,
.collapse > input[type="checkbox"],
.collapse > input[type="radio"],
.collapse-content{
  grid-column-start: 1;
  grid-row-start: 1;
}
.collapse > input[type="checkbox"],
.collapse > input[type="radio"]{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  opacity: 0;
}
.collapse-content{
  visibility: hidden;
  grid-column-start: 1;
  grid-row-start: 2;
  min-height: 0px;
  transition: visibility 0.2s;
  transition: padding 0.2s ease-out,
    background-color 0.2s ease-out;
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: unset;
}
.collapse[open],
.collapse-open,
.collapse:focus:not(.collapse-close){
  grid-template-rows: auto 1fr;
}
.collapse:not(.collapse-close):has(> input[type="checkbox"]:checked),
.collapse:not(.collapse-close):has(> input[type="radio"]:checked){
  grid-template-rows: auto 1fr;
}
.collapse[open] > .collapse-content,
.collapse-open > .collapse-content,
.collapse:focus:not(.collapse-close) > .collapse-content,
.collapse:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-content,
.collapse:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-content{
  visibility: visible;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
:root .countdown{
  line-height: 1em;
}
.countdown{
  display: inline-flex;
}
.countdown > *{
  height: 1em;
  display: inline-block;
  overflow-y: hidden;
}
.countdown > *:before{
  position: relative;
  content: "00\\A 01\\A 02\\A 03\\A 04\\A 05\\A 06\\A 07\\A 08\\A 09\\A 10\\A 11\\A 12\\A 13\\A 14\\A 15\\A 16\\A 17\\A 18\\A 19\\A 20\\A 21\\A 22\\A 23\\A 24\\A 25\\A 26\\A 27\\A 28\\A 29\\A 30\\A 31\\A 32\\A 33\\A 34\\A 35\\A 36\\A 37\\A 38\\A 39\\A 40\\A 41\\A 42\\A 43\\A 44\\A 45\\A 46\\A 47\\A 48\\A 49\\A 50\\A 51\\A 52\\A 53\\A 54\\A 55\\A 56\\A 57\\A 58\\A 59\\A 60\\A 61\\A 62\\A 63\\A 64\\A 65\\A 66\\A 67\\A 68\\A 69\\A 70\\A 71\\A 72\\A 73\\A 74\\A 75\\A 76\\A 77\\A 78\\A 79\\A 80\\A 81\\A 82\\A 83\\A 84\\A 85\\A 86\\A 87\\A 88\\A 89\\A 90\\A 91\\A 92\\A 93\\A 94\\A 95\\A 96\\A 97\\A 98\\A 99\\A";
  white-space: pre;
  top: calc(var(--value) * -1em);
  text-align: center;
  transition: all 1s cubic-bezier(1, 0, 0, 1);
}
.divider{
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1rem;
  white-space: nowrap;
}
.divider:before,
  .divider:after{
  content: "";
  flex-grow: 1;
  height: 0.125rem;
  width: 100%;
}
.drawer{
  position: relative;
  display: grid;
  grid-auto-columns: max-content auto;
  width: 100%;
}
.drawer-content{
  grid-column-start: 2;
  grid-row-start: 1;
}
.drawer-side{
  pointer-events: none;
  position: fixed;
  left: 0px;
  top: 0px;
  grid-column-start: 1;
  grid-row-start: 1;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-rows: repeat(1, minmax(0, 1fr));
  align-items: flex-start;
  justify-items: start;
  overflow-y: auto;
  overscroll-behavior: contain;
  height: 100vh;
  height: 100dvh;
  scrollbar-width: none;
}
.drawer-side::-webkit-scrollbar{
  display: none;
}
.drawer-side > .drawer-overlay{
  position: sticky;
  top: 0px;
  place-self: stretch;
  cursor: pointer;
  background-color: transparent;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
}
.drawer-side > *{
  grid-column-start: 1;
  grid-row-start: 1;
}
.drawer-side > *:not(.drawer-overlay){
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 300ms;
  transform: translateX(-100%);
}
[dir="rtl"] .drawer-side > *:not(.drawer-overlay){
  transform: translateX(-100%);
}
.drawer-toggle{
  position: fixed;
  height: 0px;
  width: 0px;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  opacity: 0;
}
.drawer-toggle:checked ~ .drawer-side{
  pointer-events: auto;
  visibility: visible;
}
.drawer-toggle:checked ~ .drawer-side > *:not(.drawer-overlay){
  transform: translateX(0%);
}
.drawer-end{
  grid-auto-columns: auto max-content;
}
.drawer-end .drawer-toggle ~ .drawer-content{
  grid-column-start: 1;
}
.drawer-end .drawer-toggle ~ .drawer-side{
  grid-column-start: 2;
  justify-items: end;
}
.drawer-end .drawer-toggle ~ .drawer-side > *:not(.drawer-overlay){
  transform: translateX(100%);
}
.drawer-end .drawer-toggle:checked ~ .drawer-side > *:not(.drawer-overlay){
  transform: translateX(0%);
}
.dropdown{
  position: relative;
  display: inline-block;
}
.dropdown > *:not(summary):focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.dropdown .dropdown-content{
  position: absolute;
}
.dropdown:is(:not(details)) .dropdown-content{
  visibility: hidden;
  opacity: 0;
  transform-origin: top;
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
}
.dropdown-end .dropdown-content{
  right: 0px;
}
.dropdown-left .dropdown-content{
  bottom: auto;
  right: 100%;
  top: 0px;
  transform-origin: right;
}
.dropdown-right .dropdown-content{
  bottom: auto;
  left: 100%;
  top: 0px;
  transform-origin: left;
}
.dropdown-bottom .dropdown-content{
  bottom: auto;
  top: 100%;
  transform-origin: top;
}
.dropdown-top .dropdown-content{
  bottom: 100%;
  top: auto;
  transform-origin: bottom;
}
.dropdown-end.dropdown-right .dropdown-content{
  bottom: 0px;
  top: auto;
}
.dropdown-end.dropdown-left .dropdown-content{
  bottom: 0px;
  top: auto;
}
.dropdown.dropdown-open .dropdown-content,
.dropdown:not(.dropdown-hover):focus .dropdown-content,
.dropdown:focus-within .dropdown-content{
  visibility: visible;
  opacity: 1;
}
@media (hover: hover){

  .dropdown.dropdown-hover:hover .dropdown-content{
    visibility: visible;
    opacity: 1;
  }

  .btm-nav > *.disabled:hover,
      .btm-nav > *[disabled]:hover{
    pointer-events: none;
    --tw-border-opacity: 0;
    background-color: hsl(var(--n) / var(--tw-bg-opacity));
    --tw-bg-opacity: 0.1;
    color: hsl(var(--bc) / var(--tw-text-opacity));
    --tw-text-opacity: 0.2;
  }

  .btm-nav > *.\\!disabled:hover{
    pointer-events: none !important;
    --tw-border-opacity: 0 !important;
    background-color: hsl(var(--n) / var(--tw-bg-opacity)) !important;
    --tw-bg-opacity: 0.1 !important;
    color: hsl(var(--bc) / var(--tw-text-opacity)) !important;
    --tw-text-opacity: 0.2 !important;
  }

  .btn:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--b3) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  }

  .btn-primary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--pf) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--pf) / var(--tw-bg-opacity));
  }

  .btn-secondary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--sf) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--sf) / var(--tw-bg-opacity));
  }

  .btn-accent:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--af) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--af) / var(--tw-bg-opacity));
  }

  .btn-neutral:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--nf) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--nf) / var(--tw-bg-opacity));
  }

  .btn-info:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--in) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--in) / var(--tw-bg-opacity));
  }

  .btn-success:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--su) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--su) / var(--tw-bg-opacity));
  }

  .btn-warning:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--wa) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  }

  .btn-error:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--er) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--er) / var(--tw-bg-opacity));
  }

  .btn.glass:hover{
    --glass-opacity: 25%;
    --glass-border-opacity: 15%;
  }

  .btn-ghost:hover{
    --tw-border-opacity: 0;
    background-color: hsl(var(--bc) / var(--tw-bg-opacity));
    --tw-bg-opacity: 0.2;
  }

  .btn-link:hover{
    border-color: transparent;
    background-color: transparent;
    text-decoration-line: underline;
  }

  .btn-outline:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--bc) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--bc) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--b1) / var(--tw-text-opacity));
  }

  .btn-outline.btn-primary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--pf) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--pf) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--pc) / var(--tw-text-opacity));
  }

  .btn-outline.btn-secondary:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--sf) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--sf) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--sc) / var(--tw-text-opacity));
  }

  .btn-outline.btn-accent:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--af) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--af) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--ac) / var(--tw-text-opacity));
  }

  .btn-outline.btn-success:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--su) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--su) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--suc) / var(--tw-text-opacity));
  }

  .btn-outline.btn-info:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--in) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--in) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--inc) / var(--tw-text-opacity));
  }

  .btn-outline.btn-warning:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--wa) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--wa) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--wac) / var(--tw-text-opacity));
  }

  .btn-outline.btn-error:hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--er) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--er) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--erc) / var(--tw-text-opacity));
  }

  .btn-disabled:hover,
    .btn[disabled]:hover,
    .btn:disabled:hover{
    --tw-border-opacity: 0;
    background-color: hsl(var(--n) / var(--tw-bg-opacity));
    --tw-bg-opacity: 0.2;
    color: hsl(var(--bc) / var(--tw-text-opacity));
    --tw-text-opacity: 0.2;
  }

  .btn:is(input[type="checkbox"]:checked):hover, .btn:is(input[type="radio"]:checked):hover{
    --tw-border-opacity: 1;
    border-color: hsl(var(--pf) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--pf) / var(--tw-bg-opacity));
  }

  .dropdown.dropdown-hover:hover .dropdown-content{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  :where(.menu li:not(.menu-title):not(.disabled) > *:not(ul):not(details):not(.menu-title)):not(.active):hover, :where(.menu li:not(.menu-title):not(.disabled) > details > summary:not(.menu-title)):not(.active):hover{
    cursor: pointer;
    background-color: hsl(var(--bc) / 0.1);
    --tw-text-opacity: 1;
    color: hsl(var(--bc) / var(--tw-text-opacity));
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .tab[disabled],
    .tab[disabled]:hover{
    cursor: not-allowed;
    color: hsl(var(--bc) / var(--tw-text-opacity));
    --tw-text-opacity: 0.2;
  }
}
.dropdown:is(details) summary::-webkit-details-marker{
  display: none;
}
.file-input{
  height: 3rem;
  flex-shrink: 1;
  padding-right: 1rem;
  font-size: 1rem;
  line-height: 2;
  line-height: 1.5rem;
  overflow: hidden;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  border-radius: var(--rounded-btn, 0.5rem);
}
.file-input::file-selector-button{
  margin-right: 1rem;
  display: inline-flex;
  height: 100%;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1em;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: hsl(var(--n) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  font-weight: 600;
  text-transform: uppercase;
  text-transform: var(--btn-text-case, uppercase);
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
  text-decoration-line: none;
  border-width: var(--border-btn, 1px);
  animation: button-pop var(--animation-btn, 0.25s) ease-out;
}
.footer{
  display: grid;
  width: 100%;
  grid-auto-flow: row;
  place-items: start;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  row-gap: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.footer > *{
  display: grid;
  place-items: start;
  gap: 0.5rem;
}
.footer-center{
  place-items: center;
  text-align: center;
}
.footer-center > *{
  place-items: center;
}
@media (min-width: 48rem){

  .footer{
    grid-auto-flow: column;
  }

  .footer-center{
    grid-auto-flow: row dense;
  }
}
.form-control{
  display: flex;
  flex-direction: column;
}
.label{
  display: flex;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.hero{
  display: grid;
  width: 100%;
  place-items: center;
  background-size: cover;
  background-position: center;
}
.hero > *{
  grid-column-start: 1;
  grid-row-start: 1;
}
.hero-overlay{
  grid-column-start: 1;
  grid-row-start: 1;
  height: 100%;
  width: 100%;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
}
.hero-content{
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 80rem;
  gap: 1rem;
  padding: 1rem;
}
.indicator{
  position: relative;
  display: inline-flex;
  width: -moz-max-content;
  width: max-content;
}
.indicator :where(.indicator-item){
  z-index: 1;
  position: absolute;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  white-space: nowrap;
}
.input{
  flex-shrink: 1;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1rem;
  line-height: 2;
  line-height: 1.5rem;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  border-radius: var(--rounded-btn, 0.5rem);
}
.input-group{
  display: flex;
  width: 100%;
  align-items: stretch;
}
.input-group > .input{
  isolation: isolate;
}
.input-group > *,
  .input-group > .input,
  .input-group > .textarea,
  .input-group > .select{
  border-radius: 0px;
}
.input-group-md{
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
}
.input-group-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
}
.input-group-sm{
  font-size: 0.875rem;
  line-height: 2rem;
}
.input-group-xs{
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
}
.input-group :where(span){
  display: flex;
  align-items: center;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
}
.input-group > :first-child{
  border-top-left-radius: var(--rounded-btn, 0.5rem);
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--rounded-btn, 0.5rem);
  border-bottom-right-radius: 0;
}
.input-group > :last-child{
  border-top-left-radius: 0;
  border-top-right-radius: var(--rounded-btn, 0.5rem);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: var(--rounded-btn, 0.5rem);
}
.input-group-vertical{
  flex-direction: column;
}
.input-group-vertical :first-child{
  border-top-left-radius: var(--rounded-btn, 0.5rem);
  border-top-right-radius: var(--rounded-btn, 0.5rem);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group-vertical :last-child{
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--rounded-btn, 0.5rem);
  border-bottom-right-radius: var(--rounded-btn, 0.5rem);
}
.join{
  display: inline-flex;
  align-items: stretch;
  border-radius: var(--rounded-btn, 0.5rem);
}
.join :where(.join-item){
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  border-start-start-radius: 0;
}
.join .join-item:not(:first-child):not(:last-child),
  .join *:not(:first-child):not(:last-child) .join-item{
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  border-start-start-radius: 0;
}
.join .join-item:first-child:not(:last-child),
  .join *:first-child:not(:last-child) .join-item{
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.join .dropdown .join-item:first-child:not(:last-child),
  .join *:first-child:not(:last-child) .dropdown .join-item{
  border-start-end-radius: inherit;
  border-end-end-radius: inherit;
}
.join :where(.join-item:first-child:not(:last-child)),
  .join :where(*:first-child:not(:last-child) .join-item){
  border-end-start-radius: inherit;
  border-start-start-radius: inherit;
}
.join .join-item:last-child:not(:first-child),
  .join *:last-child:not(:first-child) .join-item{
  border-end-start-radius: 0;
  border-start-start-radius: 0;
}
.join :where(.join-item:last-child:not(:first-child)),
  .join :where(*:last-child:not(:first-child) .join-item){
  border-start-end-radius: inherit;
  border-end-end-radius: inherit;
}
@supports not selector(:has(*)){

  :where(.join *){
    border-radius: inherit;
  }
}
@supports selector(:has(*)){

  :where(.join *:has(.join-item)){
    border-radius: inherit;
  }
}
.kbd{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: var(--rounded-btn, 0.5rem);
  border-bottom-width: 2px;
  min-height: 2.2em;
  min-width: 2.2em;
}
.link{
  cursor: pointer;
  text-decoration-line: underline;
}
.link-hover{
  text-decoration-line: none;
}
.mask{
  -webkit-mask-size: contain;
          mask-size: contain;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
}
.mask-half-1{
  -webkit-mask-size: 200%;
          mask-size: 200%;
  -webkit-mask-position: left;
          mask-position: left;
}
.mask-half-2{
  -webkit-mask-size: 200%;
          mask-size: 200%;
  -webkit-mask-position: right;
          mask-position: right;
}
.menu{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.5rem;
}
.menu :where(li ul){
  position: relative;
  white-space: nowrap;
  margin-left: 1rem;
  padding-left: 0.5rem;
}
.menu :where(li:not(.menu-title) > *:not(ul):not(details):not(.menu-title)),
  .menu :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  display: grid;
  grid-auto-flow: column;
  align-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  grid-auto-columns: minmax(auto, max-content) auto max-content;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.menu li.disabled{
  cursor: not-allowed;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  color: hsl(var(--bc) / 0.3);
}
.menu li.\\!disabled{
  cursor: not-allowed !important;
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
  color: hsl(var(--bc) / 0.3) !important;
}
.menu :where(li > .menu-dropdown:not(.menu-dropdown-show)){
  display: none;
}
:where(.menu li){
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
}
:where(.menu li) .badge{
  justify-self: end;
}
.mockup-code{
  position: relative;
  overflow: hidden;
  overflow-x: auto;
  min-width: 18rem;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.mockup-code pre[data-prefix]:before{
  content: attr(data-prefix);
  display: inline-block;
  text-align: right;
  width: 2rem;
  opacity: 0.5;
}
.mockup-window{
  position: relative;
  overflow: hidden;
  overflow-x: auto;
  padding-top: 1.25rem;
  border-radius: var(--rounded-box, 1rem);
}
.mockup-window pre[data-prefix]:before{
  content: attr(data-prefix);
  display: inline-block;
  text-align: right;
}
.mockup-browser{
  position: relative;
  overflow: hidden;
  overflow-x: auto;
  border-radius: var(--rounded-box, 1rem);
}
.mockup-browser pre[data-prefix]:before{
  content: attr(data-prefix);
  display: inline-block;
  text-align: right;
}
.modal{
  pointer-events: none;
  position: fixed;
  inset: 0px;
  margin: 0px;
  display: grid;
  height: 100%;
  max-height: none;
  width: 100%;
  max-width: none;
  justify-items: center;
  padding: 0px;
  opacity: 0;
  overscroll-behavior: contain;
  z-index: 999;
  background-color: transparent;
  color: inherit;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-property: transform, opacity, visibility;
  overflow-y: hidden;
}
.modal-scroll{
  overscroll-behavior: auto;
}
:where(.modal){
  align-items: center;
}
.modal-box{
  max-height: calc(100vh - 5em);
  grid-column-start: 1;
  grid-row-start: 1;
  width: 91.666667%;
  max-width: 32rem;
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  padding: 1.5rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
  border-bottom-left-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: var(--rounded-box, 1rem);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.modal-open,
.modal:target,
.modal-toggle:checked + .modal,
.modal[open]{
  pointer-events: auto;
  visibility: visible;
  opacity: 1;
}
.modal-action{
  display: flex;
  margin-top: 1.5rem;
  justify-content: flex-end;
}
.modal-toggle{
  position: fixed;
  height: 0px;
  width: 0px;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  opacity: 0;
}
:root:has(:is(.modal-open, .modal:target, .modal-toggle:checked + .modal, .modal[open])){
  overflow: hidden;
}
.navbar{
  display: flex;
  align-items: center;
  padding: var(--navbar-padding, 0.5rem);
  min-height: 4rem;
  width: 100%;
}
:where(.navbar > *){
  display: inline-flex;
  align-items: center;
}
.navbar-start{
  width: 50%;
  justify-content: flex-start;
}
.navbar-center{
  flex-shrink: 0;
}
.navbar-end{
  width: 50%;
  justify-content: flex-end;
}
.progress{
  position: relative;
  width: 100%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  overflow: hidden;
  height: 0.5rem;
  background-color: hsl(var(--bc) / 0.2);
  border-radius: var(--rounded-box, 1rem);
}
.radial-progress{
  position: relative;
  display: inline-grid;
  height: var(--size);
  width: var(--size);
  place-content: center;
  border-radius: 9999px;
  background-color: transparent;
  vertical-align: middle;
  box-sizing: content-box;
  --value: 0;
  --size: 5rem;
  --thickness: calc(var(--size) / 10);
}
.radial-progress::-moz-progress-bar{
  -moz-appearance: none;
       appearance: none;
  background-color: transparent;
}
.radial-progress::-webkit-progress-value{
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
}
.radial-progress::-webkit-progress-bar{
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
}
.radial-progress:before,
.radial-progress:after{
  position: absolute;
  border-radius: 9999px;
  content: "";
}
.radial-progress:before{
  inset: 0px;
  background: radial-gradient(farthest-side, currentColor 98%, #0000) top/var(--thickness) var(--thickness)
      no-repeat,
    conic-gradient(currentColor calc(var(--value) * 1%), #0000 0);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(99% - var(--thickness)),
    #000 calc(100% - var(--thickness))
  );
  mask: radial-gradient(
    farthest-side,
    #0000 calc(99% - var(--thickness)),
    #000 calc(100% - var(--thickness))
  );
}
.radial-progress:after{
  inset: calc(50% - var(--thickness) / 2);
  transform: rotate(calc(var(--value) * 3.6deg - 90deg)) translate(calc(var(--size) / 2 - 50%));
  background-color: currentColor;
}
.radio{
  flex-shrink: 0;
  --chkbg: var(--bc);
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 9999px;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}
.range{
  height: 1.5rem;
  width: 100%;
  cursor: pointer;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  --range-shdw: var(--bc);
  overflow: hidden;
  background-color: transparent;
  border-radius: var(--rounded-box, 1rem);
}
.range:focus{
  outline: none;
}
.rating{
  position: relative;
  display: inline-flex;
}
.rating :where(input){
  cursor: pointer;
  border-radius: 0px;
  animation: rating-pop var(--animation-input, 0.25s) ease-out;
  height: 1.5rem;
  width: 1.5rem;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  --tw-bg-opacity: 1;
}
.select{
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  min-height: 3rem;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  border-radius: var(--rounded-btn, 0.5rem);
  background-image: linear-gradient(45deg, transparent 50%, currentColor 50%),
    linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position: calc(100% - 20px) calc(1px + 50%),
    calc(100% - 16.1px) calc(1px + 50%);
  background-size: 4px 4px,
    4px 4px;
  background-repeat: no-repeat;
}
.select[multiple]{
  height: auto;
}
.stack{
  display: inline-grid;
  place-items: center;
  align-items: flex-end;
}
.stack > *{
  grid-column-start: 1;
  grid-row-start: 1;
  transform: translateY(10%) scale(0.9);
  z-index: 1;
  width: 100%;
  opacity: 0.6;
}
.stack > *:nth-child(2){
  transform: translateY(5%) scale(0.95);
  z-index: 2;
  opacity: 0.8;
}
.stack > *:nth-child(1){
  transform: translateY(0) scale(1);
  z-index: 3;
  opacity: 1;
}
.stats{
  display: inline-grid;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  border-radius: var(--rounded-box, 1rem);
}
:where(.stats){
  grid-auto-flow: column;
  overflow-x: auto;
}
.stat{
  display: inline-grid;
  width: 100%;
  grid-template-columns: repeat(1, 1fr);
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.stat-figure{
  grid-column-start: 2;
  grid-row: span 3 / span 3;
  grid-row-start: 1;
  place-self: center;
  justify-self: end;
}
.stat-title{
  grid-column-start: 1;
  white-space: nowrap;
  color: hsl(var(--bc) / 0.6);
}
.stat-value{
  grid-column-start: 1;
  white-space: nowrap;
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 800;
}
.stat-desc{
  grid-column-start: 1;
  white-space: nowrap;
  font-size: 0.75rem;
  line-height: 1rem;
  color: hsl(var(--bc) / 0.6);
}
.stat-actions{
  grid-column-start: 1;
  white-space: nowrap;
  margin-top: 1rem;
}
.steps{
  display: inline-grid;
  grid-auto-flow: column;
  overflow: hidden;
  overflow-x: auto;
  counter-reset: step;
  grid-auto-columns: 1fr;
}
.steps .step{
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-columns: auto;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-rows: 40px 1fr;
  place-items: center;
  text-align: center;
  min-width: 4rem;
}
.swap{
  position: relative;
  display: inline-grid;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  place-content: center;
  cursor: pointer;
}
.swap > *{
  grid-column-start: 1;
  grid-row-start: 1;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-property: transform, opacity;
}
.swap input{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.swap .swap-on,
.swap .swap-indeterminate,
.swap input:indeterminate ~ .swap-on{
  opacity: 0;
}
.swap input:checked ~ .swap-off,
.swap-active .swap-off,
.swap input:indeterminate ~ .swap-off{
  opacity: 0;
}
.swap input:checked ~ .swap-on,
.swap-active .swap-on,
.swap input:indeterminate ~ .swap-indeterminate{
  opacity: 1;
}
.tabs{
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.tab{
  position: relative;
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  --tab-padding: 1rem;
  --tw-text-opacity: 0.5;
  --tab-color: hsl(var(--bc) / var(--tw-text-opacity, 1));
  --tab-bg: hsl(var(--b1) / var(--tw-bg-opacity, 1));
  --tab-border-color: hsl(var(--b3) / var(--tw-bg-opacity, 1));
  color: var(--tab-color);
  padding-left: var(--tab-padding, 1rem);
  padding-right: var(--tab-padding, 1rem);
}
.table{
  position: relative;
  width: 100%;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-radius: var(--rounded-box, 1rem);
}
.table :where(.table-pin-rows thead tr){
  position: sticky;
  top: 0px;
  z-index: 1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
}
.table :where(.table-pin-rows tfoot tr){
  position: sticky;
  bottom: 0px;
  z-index: 1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
}
.table :where(.table-pin-cols tr th){
  position: sticky;
  left: 0px;
  right: 0px;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
}
.table-zebra tbody tr:nth-child(even) :where(.table-pin-cols tr th){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
}
.textarea{
  flex-shrink: 1;
  min-height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  border-radius: var(--rounded-btn, 0.5rem);
}
.toast{
  position: fixed;
  display: flex;
  min-width: -moz-fit-content;
  min-width: fit-content;
  flex-direction: column;
  white-space: nowrap;
  gap: 0.5rem;
  padding: 1rem;
}
.toggle{
  flex-shrink: 0;
  --tglbg: hsl(var(--b1));
  --handleoffset: 1.5rem;
  --handleoffsetcalculator: calc(var(--handleoffset) * -1);
  --togglehandleborder: 0 0;
  height: 1.5rem;
  width: 3rem;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-width: 1px;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
  border-radius: var(--rounded-badge, 1.9rem);
  transition: background,
    box-shadow var(--animation-input, 0.2s) ease-out;
  box-shadow: var(--handleoffsetcalculator) 0 0 2px var(--tglbg) inset,
    0 0 0 2px var(--tglbg) inset,
    var(--togglehandleborder);
}
.alert-info{
  border-color: hsl(var(--in) / 0.2);
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
  --alert-bg: hsl(var(--in));
  --alert-bg-mix: hsl(var(--b1));
}
.alert-success{
  border-color: hsl(var(--su) / 0.2);
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
  --alert-bg: hsl(var(--su));
  --alert-bg-mix: hsl(var(--b1));
}
.alert-warning{
  border-color: hsl(var(--wa) / 0.2);
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
  --alert-bg: hsl(var(--wa));
  --alert-bg-mix: hsl(var(--b1));
}
.alert-error{
  border-color: hsl(var(--er) / 0.2);
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
  --alert-bg: hsl(var(--er));
  --alert-bg-mix: hsl(var(--b1));
}
.avatar-group{
  display: flex;
  overflow: hidden;
}
.avatar-group :where(.avatar){
  overflow: hidden;
  border-radius: 9999px;
  border-width: 4px;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b1) / var(--tw-border-opacity));
}
.badge-neutral{
  --tw-border-opacity: 1;
  border-color: hsl(var(--n) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
}
.badge-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.badge-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.badge-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.badge-info{
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.badge-success{
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.badge-warning{
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.badge-error{
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.badge-ghost{
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
}
.badge-outline{
  border-color: currentColor;
  --tw-border-opacity: 0.5;
  background-color: transparent;
  color: currentColor;
}
.badge-outline.badge-neutral{
  --tw-text-opacity: 1;
  color: hsl(var(--n) / var(--tw-text-opacity));
}
.badge-outline.badge-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--p) / var(--tw-text-opacity));
}
.badge-outline.badge-secondary{
  --tw-text-opacity: 1;
  color: hsl(var(--s) / var(--tw-text-opacity));
}
.badge-outline.badge-accent{
  --tw-text-opacity: 1;
  color: hsl(var(--a) / var(--tw-text-opacity));
}
.badge-outline.badge-info{
  --tw-text-opacity: 1;
  color: hsl(var(--in) / var(--tw-text-opacity));
}
.badge-outline.badge-success{
  --tw-text-opacity: 1;
  color: hsl(var(--su) / var(--tw-text-opacity));
}
.badge-outline.badge-warning{
  --tw-text-opacity: 1;
  color: hsl(var(--wa) / var(--tw-text-opacity));
}
.badge-outline.badge-error{
  --tw-text-opacity: 1;
  color: hsl(var(--er) / var(--tw-text-opacity));
}
.btm-nav > *:not(.active){
  padding-top: 0.125rem;
}
.btm-nav > *:where(.active){
  border-top-width: 2px;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
}
.btm-nav > *.disabled,
    .btm-nav > *[disabled]{
  pointer-events: none;
  --tw-border-opacity: 0;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  --tw-text-opacity: 0.2;
}
.btm-nav > *.\\!disabled{
  pointer-events: none !important;
  --tw-border-opacity: 0 !important;
  background-color: hsl(var(--n) / var(--tw-bg-opacity)) !important;
  --tw-bg-opacity: 0.1 !important;
  color: hsl(var(--bc) / var(--tw-text-opacity)) !important;
  --tw-text-opacity: 0.2 !important;
}
.btm-nav > * .label{
  font-size: 1rem;
  line-height: 1.5rem;
}
.breadcrumbs > ul > li > a:focus, .breadcrumbs > ol > li > a:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.breadcrumbs > ul > li > a:focus-visible, .breadcrumbs > ol > li > a:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.breadcrumbs > ul > li + *:before, .breadcrumbs > ol > li + *:before{
  content: "";
  margin-left: 0.5rem;
  margin-right: 0.75rem;
  display: block;
  height: 0.375rem;
  width: 0.375rem;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 0.4;
  border-top: 1px solid;
  border-right: 1px solid;
  background-color: transparent;
}
[dir="rtl"] .breadcrumbs > ul > li + *:before,
[dir="rtl"] .breadcrumbs > ol > li + *:before{
  --tw-rotate: -45deg;
}
.btn:active:hover,
  .btn:active:focus{
  animation: button-pop 0s ease-out;
  transform: scale(var(--btn-focus-scale, 0.97));
}
.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--b3) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
}
.btn:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
}
.btn-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
  outline-color: hsl(var(--p) / 1);
}
.btn-primary.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--pf) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--pf) / var(--tw-bg-opacity));
}
.btn-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
  outline-color: hsl(var(--s) / 1);
}
.btn-secondary.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--sf) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--sf) / var(--tw-bg-opacity));
}
.btn-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
  outline-color: hsl(var(--a) / 1);
}
.btn-accent.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--af) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--af) / var(--tw-bg-opacity));
}
.btn-neutral{
  --tw-border-opacity: 1;
  border-color: hsl(var(--n) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
  outline-color: hsl(var(--n) / 1);
}
.btn-neutral.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--nf) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nf) / var(--tw-bg-opacity));
}
.btn-info{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
  outline-color: hsl(var(--in) / 1);
}
.btn-info.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
}
.btn-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
  outline-color: hsl(var(--su) / 1);
}
.btn-success.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
}
.btn-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
  outline-color: hsl(var(--wa) / 1);
}
.btn-warning.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
}
.btn-error{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
  outline-color: hsl(var(--er) / 1);
}
.btn-error.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
}
.btn.glass{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline-color: currentColor;
}
.btn.glass.btn-active{
  --glass-opacity: 25%;
  --glass-border-opacity: 15%;
}
.btn-ghost{
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
  color: currentColor;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline-color: currentColor;
}
.btn-ghost.btn-active{
  --tw-border-opacity: 0;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
}
.btn-link{
  border-color: transparent;
  background-color: transparent;
  --tw-text-opacity: 1;
  color: hsl(var(--p) / var(--tw-text-opacity));
  text-decoration-line: underline;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline-color: currentColor;
}
.btn-link.btn-active{
  border-color: transparent;
  background-color: transparent;
  text-decoration-line: underline;
}
.btn-outline{
  border-color: currentColor;
  background-color: transparent;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-outline.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--b1) / var(--tw-text-opacity));
}
.btn-outline.btn-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--p) / var(--tw-text-opacity));
}
.btn-outline.btn-primary.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--pf) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--pf) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.btn-outline.btn-secondary{
  --tw-text-opacity: 1;
  color: hsl(var(--s) / var(--tw-text-opacity));
}
.btn-outline.btn-secondary.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--sf) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--sf) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.btn-outline.btn-accent{
  --tw-text-opacity: 1;
  color: hsl(var(--a) / var(--tw-text-opacity));
}
.btn-outline.btn-accent.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--af) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--af) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.btn-outline.btn-success{
  --tw-text-opacity: 1;
  color: hsl(var(--su) / var(--tw-text-opacity));
}
.btn-outline.btn-success.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.btn-outline.btn-info{
  --tw-text-opacity: 1;
  color: hsl(var(--in) / var(--tw-text-opacity));
}
.btn-outline.btn-info.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.btn-outline.btn-warning{
  --tw-text-opacity: 1;
  color: hsl(var(--wa) / var(--tw-text-opacity));
}
.btn-outline.btn-warning.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.btn-outline.btn-error{
  --tw-text-opacity: 1;
  color: hsl(var(--er) / var(--tw-text-opacity));
}
.btn-outline.btn-error.btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.btn.btn-disabled,
  .btn[disabled],
  .btn:disabled{
  --tw-border-opacity: 0;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  --tw-text-opacity: 0.2;
}
.btn-group > input[type="radio"]:checked.btn,
  .btn-group > .btn-active{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.btn-group > input[type="radio"]:checked.btn:focus-visible, .btn-group > .btn-active:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-color: hsl(var(--p) / 1);
}
.btn:is(input[type="checkbox"]:checked),
.btn:is(input[type="radio"]:checked){
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.btn:is(input[type="checkbox"]:checked):focus-visible, .btn:is(input[type="radio"]:checked):focus-visible{
  outline-color: hsl(var(--p) / 1);
}
@keyframes button-pop{

  0%{
    transform: scale(var(--btn-focus-scale, 0.98));
  }

  40%{
    transform: scale(1.02);
  }

  100%{
    transform: scale(1);
  }
}
.card :where(figure:first-child){
  overflow: hidden;
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
  border-end-start-radius: unset;
  border-end-end-radius: unset;
}
.card :where(figure:last-child){
  overflow: hidden;
  border-start-start-radius: unset;
  border-start-end-radius: unset;
  border-end-start-radius: inherit;
  border-end-end-radius: inherit;
}
.card:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.card.bordered{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
}
.card-bordered{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
}
.card.compact .card-body{
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.card-title{
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
}
.card.image-full :where(figure){
  overflow: hidden;
  border-radius: inherit;
}
.carousel::-webkit-scrollbar{
  display: none;
}
.chat-bubble-primary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.chat-bubble-secondary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.chat-bubble-accent{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.chat-bubble-info{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.chat-bubble-success{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.chat-bubble-warning{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.chat-bubble-error{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.\\!checkbox:focus-visible{
  outline-style: solid !important;
  outline-width: 2px !important;
  outline-offset: 2px !important;
  outline-color: hsl(var(--bc) / 1) !important;
}
.checkbox:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 1);
}
.\\!checkbox:checked,
  .\\!checkbox[checked="true"],
  .\\!checkbox[aria-checked="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity)) !important;
  background-repeat: no-repeat !important;
  animation: checkmark var(--animation-input, 0.2s) ease-out !important;
  background-image: linear-gradient(-45deg, transparent 65%, hsl(var(--chkbg)) 65.99%),
      linear-gradient(45deg, transparent 75%, hsl(var(--chkbg)) 75.99%),
      linear-gradient(-45deg, hsl(var(--chkbg)) 40%, transparent 40.99%),
      linear-gradient(
        45deg,
        hsl(var(--chkbg)) 30%,
        hsl(var(--chkfg)) 30.99%,
        hsl(var(--chkfg)) 40%,
        transparent 40.99%
      ),
      linear-gradient(-45deg, hsl(var(--chkfg)) 50%, hsl(var(--chkbg)) 50.99%) !important;
}
.checkbox:checked,
  .checkbox[checked="true"],
  .checkbox[aria-checked="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  background-repeat: no-repeat;
  animation: checkmark var(--animation-input, 0.2s) ease-out;
  background-image: linear-gradient(-45deg, transparent 65%, hsl(var(--chkbg)) 65.99%),
      linear-gradient(45deg, transparent 75%, hsl(var(--chkbg)) 75.99%),
      linear-gradient(-45deg, hsl(var(--chkbg)) 40%, transparent 40.99%),
      linear-gradient(
        45deg,
        hsl(var(--chkbg)) 30%,
        hsl(var(--chkfg)) 30.99%,
        hsl(var(--chkfg)) 40%,
        transparent 40.99%
      ),
      linear-gradient(-45deg, hsl(var(--chkfg)) 50%, hsl(var(--chkbg)) 50.99%);
}
.\\!checkbox:checked,
  .\\!checkbox[checked="true"],
  .\\!checkbox[aria-checked="true"]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity)) !important;
  background-repeat: no-repeat !important;
  animation: checkmark var(--animation-input, 0.2s) ease-out !important;
  background-image: linear-gradient(-45deg, transparent 65%, hsl(var(--chkbg)) 65.99%),
      linear-gradient(45deg, transparent 75%, hsl(var(--chkbg)) 75.99%),
      linear-gradient(-45deg, hsl(var(--chkbg)) 40%, transparent 40.99%),
      linear-gradient(
        45deg,
        hsl(var(--chkbg)) 30%,
        hsl(var(--chkfg)) 30.99%,
        hsl(var(--chkfg)) 40%,
        transparent 40.99%
      ),
      linear-gradient(-45deg, hsl(var(--chkfg)) 50%, hsl(var(--chkbg)) 50.99%) !important;
}
.\\!checkbox:indeterminate{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity)) !important;
  background-repeat: no-repeat !important;
  animation: checkmark var(--animation-input, 0.2s) ease-out !important;
  background-image: linear-gradient(90deg, transparent 80%, hsl(var(--chkbg)) 80%),
      linear-gradient(-90deg, transparent 80%, hsl(var(--chkbg)) 80%),
      linear-gradient(
        0deg,
        hsl(var(--chkbg)) 43%,
        hsl(var(--chkfg)) 43%,
        hsl(var(--chkfg)) 57%,
        hsl(var(--chkbg)) 57%
      ) !important;
}
.checkbox:indeterminate{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  background-repeat: no-repeat;
  animation: checkmark var(--animation-input, 0.2s) ease-out;
  background-image: linear-gradient(90deg, transparent 80%, hsl(var(--chkbg)) 80%),
      linear-gradient(-90deg, transparent 80%, hsl(var(--chkbg)) 80%),
      linear-gradient(
        0deg,
        hsl(var(--chkbg)) 43%,
        hsl(var(--chkfg)) 43%,
        hsl(var(--chkfg)) 57%,
        hsl(var(--chkbg)) 57%
      );
}
.checkbox-primary{
  --chkbg: var(--p);
  --chkfg: var(--pc);
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
}
.checkbox-primary:focus-visible{
  outline-color: hsl(var(--p) / 1);
}
.checkbox-primary:checked,
    .checkbox-primary[checked="true"],
    .checkbox-primary[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.checkbox-secondary{
  --chkbg: var(--s);
  --chkfg: var(--sc);
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
}
.checkbox-secondary:focus-visible{
  outline-color: hsl(var(--s) / 1);
}
.checkbox-secondary:checked,
    .checkbox-secondary[checked="true"],
    .checkbox-secondary[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.checkbox-accent{
  --chkbg: var(--a);
  --chkfg: var(--ac);
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.checkbox-accent:focus-visible{
  outline-color: hsl(var(--a) / 1);
}
.checkbox-accent:checked,
    .checkbox-accent[checked="true"],
    .checkbox-accent[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.checkbox-success{
  --chkbg: var(--su);
  --chkfg: var(--suc);
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.checkbox-success:focus-visible{
  outline-color: hsl(var(--su) / 1);
}
.checkbox-success:checked,
    .checkbox-success[checked="true"],
    .checkbox-success[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.checkbox-warning{
  --chkbg: var(--wa);
  --chkfg: var(--wac);
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.checkbox-warning:focus-visible{
  outline-color: hsl(var(--wa) / 1);
}
.checkbox-warning:checked,
    .checkbox-warning[checked="true"],
    .checkbox-warning[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.checkbox-info{
  --chkbg: var(--in);
  --chkfg: var(--inc);
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.checkbox-info:focus-visible{
  outline-color: hsl(var(--in) / 1);
}
.checkbox-info:checked,
    .checkbox-info[checked="true"],
    .checkbox-info[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.checkbox-error{
  --chkbg: var(--er);
  --chkfg: var(--erc);
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.checkbox-error:focus-visible{
  outline-color: hsl(var(--er) / 1);
}
.checkbox-error:checked,
    .checkbox-error[checked="true"],
    .checkbox-error[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.\\!checkbox:disabled{
  cursor: not-allowed !important;
  border-color: transparent !important;
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity)) !important;
  opacity: 0.2 !important;
}
.checkbox:disabled{
  cursor: not-allowed;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  opacity: 0.2;
}
@keyframes checkmark{

  0%{
    background-position-y: 5px;
  }

  50%{
    background-position-y: -2px;
  }

  100%{
    background-position-y: 0;
  }
}
.checkbox-mark{
  display: none;
}
[dir="rtl"] .\\!checkbox:checked,
    [dir="rtl"] .\\!checkbox[checked="true"],
    [dir="rtl"] .\\!checkbox[aria-checked="true"]{
  background-image: linear-gradient(45deg, transparent 65%, hsl(var(--chkbg)) 65.99%),
        linear-gradient(-45deg, transparent 75%, hsl(var(--chkbg)) 75.99%),
        linear-gradient(45deg, hsl(var(--chkbg)) 40%, transparent 40.99%),
        linear-gradient(
          -45deg,
          hsl(var(--chkbg)) 30%,
          hsl(var(--chkfg)) 30.99%,
          hsl(var(--chkfg)) 40%,
          transparent 40.99%
        ),
        linear-gradient(45deg, hsl(var(--chkfg)) 50%, hsl(var(--chkbg)) 50.99%) !important;
}
[dir="rtl"] .checkbox:checked,
    [dir="rtl"] .checkbox[checked="true"],
    [dir="rtl"] .checkbox[aria-checked="true"]{
  background-image: linear-gradient(45deg, transparent 65%, hsl(var(--chkbg)) 65.99%),
        linear-gradient(-45deg, transparent 75%, hsl(var(--chkbg)) 75.99%),
        linear-gradient(45deg, hsl(var(--chkbg)) 40%, transparent 40.99%),
        linear-gradient(
          -45deg,
          hsl(var(--chkbg)) 30%,
          hsl(var(--chkfg)) 30.99%,
          hsl(var(--chkfg)) 40%,
          transparent 40.99%
        ),
        linear-gradient(45deg, hsl(var(--chkfg)) 50%, hsl(var(--chkbg)) 50.99%);
}
[dir="rtl"] .\\!checkbox:checked,
    [dir="rtl"] .\\!checkbox[checked="true"],
    [dir="rtl"] .\\!checkbox[aria-checked="true"]{
  background-image: linear-gradient(45deg, transparent 65%, hsl(var(--chkbg)) 65.99%),
        linear-gradient(-45deg, transparent 75%, hsl(var(--chkbg)) 75.99%),
        linear-gradient(45deg, hsl(var(--chkbg)) 40%, transparent 40.99%),
        linear-gradient(
          -45deg,
          hsl(var(--chkbg)) 30%,
          hsl(var(--chkfg)) 30.99%,
          hsl(var(--chkfg)) 40%,
          transparent 40.99%
        ),
        linear-gradient(45deg, hsl(var(--chkfg)) 50%, hsl(var(--chkbg)) 50.99%) !important;
}
details.collapse{
  width: 100%;
}
details.collapse summary{
  position: relative;
  display: block;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
details.collapse summary::-webkit-details-marker{
  display: none;
}
.collapse:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 1);
}
.collapse:has(.collapse-title:focus-visible),
.collapse:has(> input[type="checkbox"]:focus-visible),
.collapse:has(> input[type="radio"]:focus-visible){
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 1);
}
.collapse-arrow > .collapse-title:after{
  position: absolute;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  --tw-translate-y: -100%;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 0.2s;
  top: 50%;
  right: 1.4rem;
  content: "";
  transform-origin: 75% 75%;
  box-shadow: 2px 2px;
  pointer-events: none;
}
[dir="rtl"] .collapse-arrow > .collapse-title:after{
  --tw-rotate: -45deg;
}
.collapse-plus > .collapse-title:after{
  position: absolute;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 300ms;
  top: 0.9rem;
  right: 1.4rem;
  content: "+";
  pointer-events: none;
}
.collapse:not(.collapse-open):not(.collapse-close) > input[type="checkbox"],
.collapse:not(.collapse-open):not(.collapse-close) > input[type="radio"]:not(:checked),
.collapse:not(.collapse-open):not(.collapse-close) > .collapse-title{
  cursor: pointer;
}
.collapse:focus:not(.collapse-open):not(.collapse-close):not(.collapse[open]) > .collapse-title{
  cursor: unset;
}
.collapse-title{
  position: relative;
}
:where(.collapse > input[type="checkbox"]),
:where(.collapse > input[type="radio"]){
  z-index: 1;
}
.collapse-title,
:where(.collapse > input[type="checkbox"]),
:where(.collapse > input[type="radio"]){
  width: 100%;
  padding: 1rem;
  padding-right: 3rem;
  min-height: 3.75rem;
  transition: background-color 0.2s ease-out;
}
.collapse[open] > :where(.collapse-content),
.collapse-open > :where(.collapse-content),
.collapse:focus:not(.collapse-close) > :where(.collapse-content),
.collapse:not(.collapse-close) > :where(input[type="checkbox"]:checked ~ .collapse-content),
.collapse:not(.collapse-close) > :where(input[type="radio"]:checked ~ .collapse-content){
  padding-bottom: 1rem;
  transition: padding 0.2s ease-out,
    background-color 0.2s ease-out;
}
.collapse[open].collapse-arrow > .collapse-title:after,
.collapse-open.collapse-arrow > .collapse-title:after,
.collapse-arrow:focus:not(.collapse-close) > .collapse-title:after,
.collapse-arrow:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-title:after,
.collapse-arrow:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-title:after{
  --tw-translate-y: -50%;
  --tw-rotate: 225deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
[dir="rtl"] .collapse[open].collapse-arrow > .collapse-title:after,
[dir="rtl"] .collapse-open.collapse-arrow > .collapse-title:after,
[dir="rtl"] .collapse-arrow:focus:not(.collapse-close) .collapse-title:after,
[dir="rtl"]
  .collapse-arrow:not(.collapse-close)
  input[type="checkbox"]:checked
  ~ .collapse-title:after{
  --tw-rotate: 135deg;
}
.collapse[open].collapse-plus > .collapse-title:after,
.collapse-open.collapse-plus > .collapse-title:after,
.collapse-plus:focus:not(.collapse-close) > .collapse-title:after,
.collapse-plus:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-title:after,
.collapse-plus:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-title:after{
  content: "−";
}
.divider:before{
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
}
.divider:after{
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
}
.divider:not(:empty){
  gap: 1rem;
}
.drawer-toggle:checked ~ .drawer-side > .drawer-overlay{
  background-color: hsl(0 0% 0%/0.4);
}
.drawer-toggle:focus-visible ~ .drawer-content label.drawer-button{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
}
.dropdown.dropdown-open .dropdown-content,
.dropdown:focus .dropdown-content,
.dropdown:focus-within .dropdown-content{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.file-input-bordered{
  --tw-border-opacity: 0.2;
}
.file-input:focus{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 0.2);
}
.file-input-ghost{
  --tw-bg-opacity: 0.05;
}
.file-input-ghost:focus{
  --tw-bg-opacity: 1;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  box-shadow: none;
}
.file-input-ghost::file-selector-button{
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
  color: currentColor;
}
.file-input-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
}
.file-input-primary:focus{
  outline-color: hsl(var(--p) / 1);
}
.file-input-primary::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.file-input-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
}
.file-input-secondary:focus{
  outline-color: hsl(var(--s) / 1);
}
.file-input-secondary::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.file-input-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.file-input-accent:focus{
  outline-color: hsl(var(--a) / 1);
}
.file-input-accent::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.file-input-info{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.file-input-info:focus{
  outline-color: hsl(var(--in) / 1);
}
.file-input-info::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.file-input-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.file-input-success:focus{
  outline-color: hsl(var(--su) / 1);
}
.file-input-success::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.file-input-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.file-input-warning:focus{
  outline-color: hsl(var(--wa) / 1);
}
.file-input-warning::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.file-input-error{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.file-input-error:focus{
  outline-color: hsl(var(--er) / 1);
}
.file-input-error::file-selector-button{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.file-input-disabled,
  .file-input[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  --tw-text-opacity: 0.2;
}
.file-input-disabled::-moz-placeholder, .file-input[disabled]::-moz-placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.file-input-disabled::placeholder,
  .file-input[disabled]::placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.file-input-disabled::file-selector-button, .file-input[disabled]::file-selector-button{
  --tw-border-opacity: 0;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  --tw-text-opacity: 0.2;
}
.footer-title{
  margin-bottom: 0.5rem;
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.5;
}
.label-text{
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
}
.label-text-alt{
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
}
.input input:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.input[list]::-webkit-calendar-picker-indicator{
  line-height: 1em;
}
.input-bordered{
  --tw-border-opacity: 0.2;
}
.input:focus,
  .input:focus-within{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 0.2);
}
.input-ghost{
  --tw-bg-opacity: 0.05;
}
.input-ghost:focus,
    .input-ghost:focus-within{
  --tw-bg-opacity: 1;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  box-shadow: none;
}
.input-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
}
.input-primary:focus,
    .input-primary:focus-within{
  outline-color: hsl(var(--p) / 1);
}
.input-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
}
.input-secondary:focus,
    .input-secondary:focus-within{
  outline-color: hsl(var(--s) / 1);
}
.input-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.input-accent:focus,
    .input-accent:focus-within{
  outline-color: hsl(var(--a) / 1);
}
.input-info{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.input-info:focus,
    .input-info:focus-within{
  outline-color: hsl(var(--in) / 1);
}
.input-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.input-success:focus,
    .input-success:focus-within{
  outline-color: hsl(var(--su) / 1);
}
.input-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.input-warning:focus,
    .input-warning:focus-within{
  outline-color: hsl(var(--wa) / 1);
}
.input-error{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.input-error:focus,
    .input-error:focus-within{
  outline-color: hsl(var(--er) / 1);
}
.input-disabled,
  .input:disabled,
  .input[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  --tw-text-opacity: 0.2;
}
.input-disabled::-moz-placeholder, .input:disabled::-moz-placeholder, .input[disabled]::-moz-placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.input-disabled::placeholder,
  .input:disabled::placeholder,
  .input[disabled]::placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.join > :where(*:not(:first-child)){
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: -1px;
}
.join-item:focus{
  isolation: isolate;
}
.link-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--p) / var(--tw-text-opacity));
}
.link-secondary{
  --tw-text-opacity: 1;
  color: hsl(var(--s) / var(--tw-text-opacity));
}
.link-accent{
  --tw-text-opacity: 1;
  color: hsl(var(--a) / var(--tw-text-opacity));
}
.link-neutral{
  --tw-text-opacity: 1;
  color: hsl(var(--n) / var(--tw-text-opacity));
}
.link-success{
  --tw-text-opacity: 1;
  color: hsl(var(--su) / var(--tw-text-opacity));
}
.link-info{
  --tw-text-opacity: 1;
  color: hsl(var(--in) / var(--tw-text-opacity));
}
.link-warning{
  --tw-text-opacity: 1;
  color: hsl(var(--wa) / var(--tw-text-opacity));
}
.link-error{
  --tw-text-opacity: 1;
  color: hsl(var(--er) / var(--tw-text-opacity));
}
.link:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.link:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.\\!loading{
  pointer-events: none !important;
  display: inline-block !important;
  aspect-ratio: 1 / 1 !important;
  width: 1.5rem !important;
  background-color: currentColor !important;
  -webkit-mask-size: 100% !important;
          mask-size: 100% !important;
  -webkit-mask-repeat: no-repeat !important;
          mask-repeat: no-repeat !important;
  -webkit-mask-position: center !important;
          mask-position: center !important;
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}
.loading{
  pointer-events: none;
  display: inline-block;
  aspect-ratio: 1 / 1;
  width: 1.5rem;
  background-color: currentColor;
  -webkit-mask-size: 100%;
          mask-size: 100%;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.loading-spinner{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.loading-dots{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.loading-ring{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.loading-ball{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.loading-bars{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.loading-infinity{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.loading-xs{
  width: 1rem;
}
.loading-sm{
  width: 1.25rem;
}
.loading-md{
  width: 1.5rem;
}
.loading-lg{
  width: 2.5rem;
}
.mask-squircle{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.mask-decagon{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.mask-diamond{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.mask-heart{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.mask-hexagon{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.mask-hexagon-2{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.mask-circle{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.mask-parallelogram{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.mask-parallelogram-2{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.mask-parallelogram-3{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.mask-parallelogram-4{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.mask-pentagon{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.mask-square{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.mask-star{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.mask-star-2{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.mask-triangle{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.mask-triangle-2{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.mask-triangle-3{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.mask-triangle-4{
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
:where(.menu li:empty){
  background-color: hsl(var(--bc) / 0.1);
  margin: 0.5rem 1rem;
  height: 1px;
}
.menu :where(li ul):before{
  position: absolute;
  bottom: 0.75rem;
  left: 0px;
  top: 0.75rem;
  width: 1px;
  background-color: hsl(var(--bc) / 0.1);
  content: "";
}
.menu :where(li:not(.menu-title) > *:not(ul):not(details):not(.menu-title)),
.menu :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: left;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  border-radius: var(--rounded-btn, 0.5rem);
  text-wrap: balance;
}
:where(.menu li:not(.menu-title):not(.disabled) > *:not(ul):not(details):not(.menu-title)):not(summary):not(.active).focus,
  :where(.menu li:not(.menu-title):not(.disabled) > *:not(ul):not(details):not(.menu-title)):not(summary):not(.active):focus,
  :where(.menu li:not(.menu-title):not(.disabled) > *:not(ul):not(details):not(.menu-title)):is(summary):not(.active):focus-visible,
  :where(.menu li:not(.menu-title):not(.disabled) > details > summary:not(.menu-title)):not(summary):not(.active).focus,
  :where(.menu li:not(.menu-title):not(.disabled) > details > summary:not(.menu-title)):not(summary):not(.active):focus,
  :where(.menu li:not(.menu-title):not(.disabled) > details > summary:not(.menu-title)):is(summary):not(.active):focus-visible{
  cursor: pointer;
  background-color: hsl(var(--bc) / 0.1);
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.menu li > *:not(ul):not(.menu-title):not(details):active,
.menu li > *:not(ul):not(.menu-title):not(details).active,
.menu li > details > summary:active{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
}
.menu :where(li > details > summary)::-webkit-details-marker{
  display: none;
}
.menu :where(li > details > summary):after,
.menu :where(li > .menu-dropdown-toggle):after{
  justify-self: end;
  display: block;
  margin-top: -0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  transform: rotate(45deg);
  transition-property: transform, margin-top;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  content: "";
  transform-origin: 75% 75%;
  box-shadow: 2px 2px;
  pointer-events: none;
}
.menu :where(li > details[open] > summary):after,
.menu :where(li > .menu-dropdown-toggle.menu-dropdown-show):after{
  transform: rotate(225deg);
  margin-top: 0;
}
.menu-title{
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: hsl(var(--bc) / 0.4);
}
.mockup-code:before{
  content: "";
  margin-bottom: 1rem;
  display: block;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 9999px;
  opacity: 0.3;
  box-shadow: 1.4em 0,
        2.8em 0,
        4.2em 0;
}
.mockup-code pre{
  padding-right: 1.25rem;
}
.mockup-code pre:before{
  content: "";
  margin-right: 2ch;
}
.mockup-window:before{
  content: "";
  margin-bottom: 1rem;
  display: block;
  aspect-ratio: 1 / 1;
  height: 0.75rem;
  border-radius: 9999px;
  opacity: 0.3;
  box-shadow: 1.4em 0,
        2.8em 0,
        4.2em 0;
}
.mockup-phone{
  display: inline-block;
  border: 4px solid #444;
  border-radius: 50px;
  background-color: #000;
  padding: 10px;
  margin: 0 auto;
  overflow: hidden;
}
.mockup-phone .camera{
  position: relative;
  top: 0px;
  left: 0px;
  background: #000;
  height: 25px;
  width: 150px;
  margin: 0 auto;
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
  z-index: 11;
}
.mockup-phone .camera:before{
  content: "";
  position: absolute;
  top: 35%;
  left: 50%;
  width: 50px;
  height: 4px;
  border-radius: 5px;
  background-color: #0c0b0e;
  transform: translate(-50%, -50%);
}
.mockup-phone .camera:after{
  content: "";
  position: absolute;
  top: 20%;
  left: 70%;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #0f0b25;
}
.mockup-phone .display{
  overflow: hidden;
  border-radius: 40px;
  margin-top: -25px;
}
.mockup-browser .mockup-browser-toolbar{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  display: inline-flex;
  width: 100%;
  align-items: center;
  padding-right: 1.4em;
}
.mockup-browser .mockup-browser-toolbar:before{
  content: "";
  margin-right: 4.8rem;
  display: inline-block;
  aspect-ratio: 1 / 1;
  height: 0.75rem;
  border-radius: 9999px;
  opacity: 0.3;
  box-shadow: 1.4em 0,
          2.8em 0,
          4.2em 0;
}
.mockup-browser .mockup-browser-toolbar .input{
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 1.75rem;
  width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  padding-left: 2rem;
}
.mockup-browser .mockup-browser-toolbar .input:before{
  content: "";
  position: absolute;
  left: 0.5rem;
  top: 50%;
  aspect-ratio: 1 / 1;
  height: 0.75rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 2px;
  border-color: currentColor;
  opacity: 0.6;
}
.mockup-browser .mockup-browser-toolbar .input:after{
  content: "";
  position: absolute;
  left: 1.25rem;
  top: 50%;
  height: 0.5rem;
  --tw-translate-y: 25%;
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 1px;
  border-color: currentColor;
  opacity: 0.6;
}
.modal:not(dialog:not(.modal-open)),
  .modal::backdrop{
  background-color: rgba(0, 0, 0, 0.3);
  animation: modal-pop 0.2s ease-out;
}
.modal-backdrop{
  z-index: -1;
  grid-column-start: 1;
  grid-row-start: 1;
  display: grid;
  align-self: stretch;
  justify-self: stretch;
  color: transparent;
}
.modal-open .modal-box,
.modal-toggle:checked + .modal .modal-box,
.modal:target .modal-box,
.modal[open] .modal-box{
  --tw-translate-y: 0px;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.modal-action > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
@keyframes modal-pop{

  0%{
    opacity: 0;
  }
}
.progress::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-primary::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-secondary::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-accent::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-info::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-success::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-warning::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-error::-moz-progress-bar{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress:indeterminate{
  --progress-color: hsl(var(--bc));
  background-image: repeating-linear-gradient(
    90deg,
    var(--progress-color) -1%,
    var(--progress-color) 10%,
    transparent 10%,
    transparent 90%
  );
  background-size: 200%;
  background-position-x: 15%;
  animation: progress-loading 5s ease-in-out infinite;
}
.progress-primary:indeterminate{
  --progress-color: hsl(var(--p));
}
.progress-secondary:indeterminate{
  --progress-color: hsl(var(--s));
}
.progress-accent:indeterminate{
  --progress-color: hsl(var(--a));
}
.progress-info:indeterminate{
  --progress-color: hsl(var(--in));
}
.progress-success:indeterminate{
  --progress-color: hsl(var(--su));
}
.progress-warning:indeterminate{
  --progress-color: hsl(var(--wa));
}
.progress-error:indeterminate{
  --progress-color: hsl(var(--er));
}
.progress::-webkit-progress-bar{
  background-color: transparent;
  border-radius: var(--rounded-box, 1rem);
}
.progress::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
}
.progress-primary::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
}
.progress-secondary::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
}
.progress-accent::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
}
.progress-info::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
}
.progress-success::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
}
.progress-warning::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
}
.progress-error::-webkit-progress-value{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
}
.progress:indeterminate::-moz-progress-bar{
  background-color: transparent;
  background-image: repeating-linear-gradient(
    90deg,
    var(--progress-color) -1%,
    var(--progress-color) 10%,
    transparent 10%,
    transparent 90%
  );
  background-size: 200%;
  background-position-x: 15%;
  animation: progress-loading 5s ease-in-out infinite;
}
@keyframes progress-loading{

  50%{
    background-position-x: -115%;
  }
}
.radio:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 1);
}
.radio:checked,
  .radio[aria-checked="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bc) / var(--tw-bg-opacity));
  animation: radiomark var(--animation-input, 0.2s) ease-out;
  box-shadow: 0 0 0 4px hsl(var(--b1)) inset,
      0 0 0 4px hsl(var(--b1)) inset;
}
.radio-primary{
  --chkbg: var(--p);
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
}
.radio-primary:focus-visible{
  outline-color: hsl(var(--p) / 1);
}
.radio-primary:checked,
    .radio-primary[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.radio-secondary{
  --chkbg: var(--s);
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
}
.radio-secondary:focus-visible{
  outline-color: hsl(var(--s) / 1);
}
.radio-secondary:checked,
    .radio-secondary[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.radio-accent{
  --chkbg: var(--a);
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.radio-accent:focus-visible{
  outline-color: hsl(var(--a) / 1);
}
.radio-accent:checked,
    .radio-accent[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.radio-success{
  --chkbg: var(--su);
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.radio-success:focus-visible{
  outline-color: hsl(var(--su) / 1);
}
.radio-success:checked,
    .radio-success[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.radio-warning{
  --chkbg: var(--wa);
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.radio-warning:focus-visible{
  outline-color: hsl(var(--wa) / 1);
}
.radio-warning:checked,
    .radio-warning[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.radio-info{
  --chkbg: var(--in);
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.radio-info:focus-visible{
  outline-color: hsl(var(--in) / 1);
}
.radio-info:checked,
    .radio-info[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.radio-error{
  --chkbg: var(--er);
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.radio-error:focus-visible{
  outline-color: hsl(var(--er) / 1);
}
.radio-error:checked,
    .radio-error[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.radio:disabled{
  cursor: not-allowed;
  opacity: 0.2;
}
@keyframes radiomark{

  0%{
    box-shadow: 0 0 0 12px hsl(var(--b1)) inset,
      0 0 0 12px hsl(var(--b1)) inset;
  }

  50%{
    box-shadow: 0 0 0 3px hsl(var(--b1)) inset,
      0 0 0 3px hsl(var(--b1)) inset;
  }

  100%{
    box-shadow: 0 0 0 4px hsl(var(--b1)) inset,
      0 0 0 4px hsl(var(--b1)) inset;
  }
}
.radio-mark{
  display: none;
}
.range:focus-visible::-webkit-slider-thumb{
  --focus-shadow: 0 0 0 6px hsl(var(--b1)) inset, 0 0 0 2rem hsl(var(--range-shdw)) inset;
}
.range:focus-visible::-moz-range-thumb{
  --focus-shadow: 0 0 0 6px hsl(var(--b1)) inset, 0 0 0 2rem hsl(var(--range-shdw)) inset;
}
.range::-webkit-slider-runnable-track{
  height: 0.5rem;
  width: 100%;
  background-color: hsl(var(--bc) / 0.1);
  border-radius: var(--rounded-box, 1rem);
}
.range::-moz-range-track{
  height: 0.5rem;
  width: 100%;
  background-color: hsl(var(--bc) / 0.1);
  border-radius: var(--rounded-box, 1rem);
}
.range::-webkit-slider-thumb{
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
  appearance: none;
  -webkit-appearance: none;
  top: 50%;
  color: hsl(var(--range-shdw));
  transform: translateY(-50%);
  --filler-size: 100rem;
  --filler-offset: 0.6rem;
  box-shadow: 0 0 0 3px hsl(var(--range-shdw)) inset,
      var(--focus-shadow, 0 0),
      calc(var(--filler-size) * -1 - var(--filler-offset)) 0 0 var(--filler-size);
}
.range::-moz-range-thumb{
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  border-radius: var(--rounded-box, 1rem);
  top: 50%;
  color: hsl(var(--range-shdw));
  --filler-size: 100rem;
  --filler-offset: 0.5rem;
  box-shadow: 0 0 0 3px hsl(var(--range-shdw)) inset,
      var(--focus-shadow, 0 0),
      calc(var(--filler-size) * -1 - var(--filler-offset)) 0 0 var(--filler-size);
}
.range-primary{
  --range-shdw: var(--p);
}
.range-secondary{
  --range-shdw: var(--s);
}
.range-accent{
  --range-shdw: var(--a);
}
.range-success{
  --range-shdw: var(--su);
}
.range-warning{
  --range-shdw: var(--wa);
}
.range-info{
  --range-shdw: var(--in);
}
.range-error{
  --range-shdw: var(--er);
}
.rating input{
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
}
.rating .rating-hidden{
  width: 0.5rem;
  background-color: transparent;
}
.rating input:checked ~ input,
  .rating input[aria-checked="true"] ~ input{
  --tw-bg-opacity: 0.2;
}
.rating input:focus-visible{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 300ms;
  transform: translateY(-0.125em);
}
.rating input:active:focus{
  animation: none;
  transform: translateY(-0.125em);
}
.rating-half :where(input:not(.rating-hidden)){
  width: 0.75rem;
}
@keyframes rating-pop{

  0%{
    transform: translateY(-0.125em);
  }

  40%{
    transform: translateY(-0.125em);
  }

  100%{
    transform: translateY(0);
  }
}
.select-bordered{
  --tw-border-opacity: 0.2;
}
.select:focus{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 0.2);
}
.select-ghost{
  --tw-bg-opacity: 0.05;
}
.select-ghost:focus{
  --tw-bg-opacity: 1;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
}
.select-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
}
.select-primary:focus{
  outline-color: hsl(var(--p) / 1);
}
.select-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
}
.select-secondary:focus{
  outline-color: hsl(var(--s) / 1);
}
.select-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.select-accent:focus{
  outline-color: hsl(var(--a) / 1);
}
.select-info{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.select-info:focus{
  outline-color: hsl(var(--in) / 1);
}
.select-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.select-success:focus{
  outline-color: hsl(var(--su) / 1);
}
.select-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.select-warning:focus{
  outline-color: hsl(var(--wa) / 1);
}
.select-error{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.select-error:focus{
  outline-color: hsl(var(--er) / 1);
}
.select-disabled,
  .select:disabled,
  .select[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  --tw-text-opacity: 0.2;
}
.select-disabled::-moz-placeholder, .select:disabled::-moz-placeholder, .select[disabled]::-moz-placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.select-disabled::placeholder,
  .select:disabled::placeholder,
  .select[disabled]::placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.select-multiple,
  .select[multiple],
  .select[size].select:not([size="1"]){
  background-image: none;
  padding-right: 1rem;
}
[dir="rtl"] .select{
  background-position: calc(0% + 12px) calc(1px + 50%),
    calc(0% + 16px) calc(1px + 50%);
}
:where(.stats) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  --tw-divide-y-reverse: 0;
  border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
}
.steps .step:before{
  top: 0px;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 0.5rem;
  width: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  content: "";
  margin-left: -100%;
}
.steps .step:after{
  content: counter(step);
  counter-increment: step;
  z-index: 1;
  position: relative;
  grid-column-start: 1;
  grid-row-start: 1;
  display: grid;
  height: 2rem;
  width: 2rem;
  place-items: center;
  place-self: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
}
.steps .step:first-child:before{
  content: none;
}
.steps .step[data-content]:after{
  content: attr(data-content);
}
.steps .step-neutral + .step-neutral:before,
  .steps .step-neutral:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
}
.steps .step-primary + .step-primary:before,
  .steps .step-primary:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.steps .step-secondary + .step-secondary:before,
  .steps .step-secondary:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.steps .step-accent + .step-accent:before,
  .steps .step-accent:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.steps .step-info + .step-info:before{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
}
.steps .step-info:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.steps .step-success + .step-success:before{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
}
.steps .step-success:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.steps .step-warning + .step-warning:before{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
}
.steps .step-warning:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.steps .step-error + .step-error:before{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
}
.steps .step-error:after{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.swap-rotate .swap-on,
.swap-rotate .swap-indeterminate,
.swap-rotate input:indeterminate ~ .swap-on{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.swap-rotate input:checked ~ .swap-off,
.swap-active:where(.swap-rotate) .swap-off,
.swap-rotate input:indeterminate ~ .swap-off{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.swap-rotate input:checked ~ .swap-on,
.swap-active:where(.swap-rotate) .swap-on,
.swap-rotate input:indeterminate ~ .swap-indeterminate{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.swap-flip{
  transform-style: preserve-3d;
  perspective: 16em;
}
.swap-flip .swap-on,
.swap-flip .swap-indeterminate,
.swap-flip input:indeterminate ~ .swap-on{
  transform: rotateY(180deg);
  backface-visibility: hidden;
  opacity: 1;
}
.swap-flip input:checked ~ .swap-off,
.swap-active:where(.swap-flip) .swap-off,
.swap-flip input:indeterminate ~ .swap-off{
  transform: rotateY(-180deg);
  backface-visibility: hidden;
  opacity: 1;
}
.swap-flip input:checked ~ .swap-on,
.swap-active:where(.swap-flip) .swap-on,
.swap-flip input:indeterminate ~ .swap-indeterminate{
  transform: rotateY(0deg);
}
.tab.tab-active:not(.tab-disabled):not([disabled]){
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 1;
  --tw-text-opacity: 1;
}
.tab:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tab:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: -3px;
}
.tab:focus-visible.tab-lifted{
  border-bottom-right-radius: var(--tab-radius, 0.5rem);
  border-bottom-left-radius: var(--tab-radius, 0.5rem);
}
.tab-disabled,
  .tab[disabled]{
  cursor: not-allowed;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  --tw-text-opacity: 0.2;
}
.tab-bordered{
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
  border-style: solid;
  border-bottom-width: calc(var(--tab-border, 1px) + 1px);
}
.tab-lifted{
  border: var(--tab-border, 1px) solid transparent;
  border-width: 0 0 var(--tab-border, 1px) 0;
  border-top-left-radius: var(--tab-radius, 0.5rem);
  border-top-right-radius: var(--tab-radius, 0.5rem);
  border-bottom-color: var(--tab-border-color);
  padding-left: var(--tab-padding, 1rem);
  padding-right: var(--tab-padding, 1rem);
  padding-top: var(--tab-border, 1px);
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled]){
  background-color: var(--tab-bg);
  border-width: var(--tab-border, 1px) var(--tab-border, 1px) 0 var(--tab-border, 1px);
  border-left-color: var(--tab-border-color);
  border-right-color: var(--tab-border-color);
  border-top-color: var(--tab-border-color);
  padding-left: calc(var(--tab-padding, 1rem) - var(--tab-border, 1px));
  padding-right: calc(var(--tab-padding, 1rem) - var(--tab-border, 1px));
  padding-bottom: var(--tab-border, 1px);
  padding-top: 0;
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled]):before,
    .tab-lifted.tab-active:not(.tab-disabled):not([disabled]):after{
  z-index: 1;
  content: "";
  display: block;
  position: absolute;
  width: var(--tab-radius, 0.5rem);
  height: var(--tab-radius, 0.5rem);
  bottom: 0;
  --tab-grad: calc(68% - var(--tab-border, 1px));
  --tab-corner-bg: radial-gradient(
        circle at var(--circle-pos),
        transparent var(--tab-grad),
        var(--tab-border-color) calc(var(--tab-grad) + 0.3px),
        var(--tab-border-color) calc(var(--tab-grad) + var(--tab-border, 1px)),
        var(--tab-bg) calc(var(--tab-grad) + var(--tab-border, 1px) + 0.3px)
      );
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled]):before{
  left: calc(var(--tab-radius, 0.5rem) * -1);
  --circle-pos: top left;
  background-image: var(--tab-corner-bg);
}
[dir="rtl"] .tab-lifted.tab-active:not(.tab-disabled):not([disabled]):before{
  --circle-pos: top right;
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled]):after{
  right: calc(var(--tab-radius, 0.5rem) * -1);
  --circle-pos: top right;
  background-image: var(--tab-corner-bg);
}
[dir="rtl"] .tab-lifted.tab-active:not(.tab-disabled):not([disabled]):after{
  --circle-pos: top left;
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled]):first-child:before{
  background: none;
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled]):last-child:after{
  background: none;
}
.tab-lifted.tab-active:not(.tab-disabled):not([disabled])
  + .tab-lifted.tab-active:not(.tab-disabled):not([disabled]):before{
  background: none;
}
.tabs-boxed{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  padding: 0.25rem;
  border-radius: var(--rounded-btn, 0.5rem);
}
.tabs-boxed .tab{
  border-radius: var(--rounded-btn, 0.5rem);
}
.tabs-boxed .tab-active:not(.tab-disabled):not([disabled]){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.table :where(th, td){
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  vertical-align: middle;
}
.table tr.active,
  .table tr.active:nth-child(even),
  .table-zebra tbody tr:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
}
.table-zebra tr.active,
    .table-zebra tr.active:nth-child(even),
    .table-zebra-zebra tbody tr:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
}
.table :where(thead, tbody) :where(tr:not(:last-child)),
    .table :where(thead, tbody) :where(tr:first-child:last-child){
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--b2) / var(--tw-border-opacity));
}
.table :where(thead, tfoot){
  white-space: nowrap;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
  color: hsl(var(--bc) / 0.6);
}
.textarea-bordered{
  --tw-border-opacity: 0.2;
}
.textarea:focus{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 0.2);
}
.textarea-ghost{
  --tw-bg-opacity: 0.05;
}
.textarea-ghost:focus{
  --tw-bg-opacity: 1;
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  box-shadow: none;
}
.textarea-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--p) / var(--tw-border-opacity));
}
.textarea-primary:focus{
  outline-color: hsl(var(--p) / 1);
}
.textarea-secondary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--s) / var(--tw-border-opacity));
}
.textarea-secondary:focus{
  outline-color: hsl(var(--s) / 1);
}
.textarea-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.textarea-accent:focus{
  outline-color: hsl(var(--a) / 1);
}
.textarea-info{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.textarea-info:focus{
  outline-color: hsl(var(--in) / 1);
}
.textarea-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.textarea-success:focus{
  outline-color: hsl(var(--su) / 1);
}
.textarea-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.textarea-warning:focus{
  outline-color: hsl(var(--wa) / 1);
}
.textarea-error{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.textarea-error:focus{
  outline-color: hsl(var(--er) / 1);
}
.textarea-disabled,
  .textarea:disabled,
  .textarea[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  --tw-text-opacity: 0.2;
}
.textarea-disabled::-moz-placeholder, .textarea:disabled::-moz-placeholder, .textarea[disabled]::-moz-placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.textarea-disabled::placeholder,
  .textarea:disabled::placeholder,
  .textarea[disabled]::placeholder{
  color: hsl(var(--bc) / var(--tw-placeholder-opacity));
  --tw-placeholder-opacity: 0.2;
}
.toast > *{
  animation: toast-pop 0.25s ease-out;
}
@keyframes toast-pop{

  0%{
    transform: scale(0.9);
    opacity: 0;
  }

  100%{
    transform: scale(1);
    opacity: 1;
  }
}
[dir="rtl"] .toggle{
  --handleoffsetcalculator: calc(var(--handleoffset) * 1);
}
.toggle:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: hsl(var(--bc) / 0.2);
}
.toggle:checked,
  .toggle[checked="true"],
  .toggle[aria-checked="true"]{
  --handleoffsetcalculator: var(--handleoffset);
  --tw-border-opacity: 1;
  --tw-bg-opacity: 1;
}
[dir="rtl"] .toggle:checked, [dir="rtl"] .toggle[checked="true"], [dir="rtl"] .toggle[aria-checked="true"]{
  --handleoffsetcalculator: calc(var(--handleoffset) * -1);
}
.toggle:indeterminate{
  --tw-border-opacity: 1;
  --tw-bg-opacity: 1;
  box-shadow: calc(var(--handleoffset) / 2) 0 0 2px var(--tglbg) inset,
      calc(var(--handleoffset) / -2) 0 0 2px var(--tglbg) inset,
      0 0 0 2px var(--tglbg) inset;
}
[dir="rtl"] .toggle:indeterminate{
  box-shadow: calc(var(--handleoffset) / 2) 0 0 2px var(--tglbg) inset,
        calc(var(--handleoffset) / -2) 0 0 2px var(--tglbg) inset,
        0 0 0 2px var(--tglbg) inset;
}
.toggle-primary:focus-visible{
  outline-color: hsl(var(--p) / 1);
}
.toggle-primary:checked,
    .toggle-primary[checked="true"],
    .toggle-primary[aria-checked="true"]{
  border-color: hsl(var(--p) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--p) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.toggle-secondary:focus-visible{
  outline-color: hsl(var(--s) / 1);
}
.toggle-secondary:checked,
    .toggle-secondary[checked="true"],
    .toggle-secondary[aria-checked="true"]{
  border-color: hsl(var(--s) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--s) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.toggle-accent:focus-visible{
  outline-color: hsl(var(--a) / 1);
}
.toggle-accent:checked,
    .toggle-accent[checked="true"],
    .toggle-accent[aria-checked="true"]{
  border-color: hsl(var(--a) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.toggle-success:focus-visible{
  outline-color: hsl(var(--su) / 1);
}
.toggle-success:checked,
    .toggle-success[checked="true"],
    .toggle-success[aria-checked="true"]{
  border-color: hsl(var(--su) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.toggle-warning:focus-visible{
  outline-color: hsl(var(--wa) / 1);
}
.toggle-warning:checked,
    .toggle-warning[checked="true"],
    .toggle-warning[aria-checked="true"]{
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.toggle-info:focus-visible{
  outline-color: hsl(var(--in) / 1);
}
.toggle-info:checked,
    .toggle-info[checked="true"],
    .toggle-info[aria-checked="true"]{
  border-color: hsl(var(--in) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.toggle-error:focus-visible{
  outline-color: hsl(var(--er) / 1);
}
.toggle-error:checked,
    .toggle-error[checked="true"],
    .toggle-error[aria-checked="true"]{
  border-color: hsl(var(--er) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.toggle:disabled{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: hsl(var(--bc) / var(--tw-border-opacity));
  background-color: transparent;
  opacity: 0.3;
  --togglehandleborder: 0 0 0 3px hsl(var(--bc)) inset,
      var(--handleoffsetcalculator) 0 0 3px hsl(var(--bc)) inset;
}
.toggle-mark{
  display: none;
}
:root .prose{
  --tw-prose-body: hsl(var(--bc) / 0.8);
  --tw-prose-headings: hsl(var(--bc));
  --tw-prose-lead: hsl(var(--bc));
  --tw-prose-links: hsl(var(--bc));
  --tw-prose-bold: hsl(var(--bc));
  --tw-prose-counters: hsl(var(--bc));
  --tw-prose-bullets: hsl(var(--bc) / 0.5);
  --tw-prose-hr: hsl(var(--bc) / 0.2);
  --tw-prose-quotes: hsl(var(--bc));
  --tw-prose-quote-borders: hsl(var(--bc) / 0.2);
  --tw-prose-captions: hsl(var(--bc) / 0.5);
  --tw-prose-code: hsl(var(--bc));
  --tw-prose-pre-code: hsl(var(--nc));
  --tw-prose-pre-bg: hsl(var(--n));
  --tw-prose-th-borders: hsl(var(--bc) / 0.5);
  --tw-prose-td-borders: hsl(var(--bc) / 0.2);
}
.prose :where(code):not(:where([class~="not-prose"] *)){
  padding: 2px 8px;
  border-radius: var(--rounded-badge);
}
.prose code:after,
  .prose code:before{
  content: none;
}
.prose pre code{
  border-radius: 0;
  padding: 0;
}
.prose :where(tbody tr, thead):not(:where([class~="not-prose"] *)){
  border-bottom-color: hsl(var(--bc) / 20%);
}
.rounded-box{
  border-radius: var(--rounded-box, 1rem);
}
.rounded-t-box{
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
}
.rounded-b-box{
  border-bottom-left-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: var(--rounded-box, 1rem);
}
.rounded-l-box{
  border-top-left-radius: var(--rounded-box, 1rem);
  border-bottom-left-radius: var(--rounded-box, 1rem);
}
.rounded-r-box{
  border-top-right-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: var(--rounded-box, 1rem);
}
.rounded-br-box{
  border-bottom-right-radius: var(--rounded-box, 1rem);
}
.rounded-tr-box{
  border-top-right-radius: var(--rounded-box, 1rem);
}
.rounded-bl-box{
  border-bottom-left-radius: var(--rounded-box, 1rem);
}
.rounded-tl-box{
  border-top-left-radius: var(--rounded-box, 1rem);
}
.rounded-btn{
  border-radius: var(--rounded-btn, 0.5rem);
}
.rounded-badge{
  border-radius: var(--rounded-badge, 1.9rem);
}
.glass,
  .glass.btn-active{
  border: none;
  -webkit-backdrop-filter: blur(var(--glass-blur, 40px));
          backdrop-filter: blur(var(--glass-blur, 40px));
  background-color: transparent;
  background-image: linear-gradient(
        135deg,
        rgb(255 255 255 / var(--glass-opacity, 30%)) 0%,
        rgb(0 0 0 / 0%) 100%
      ),
      linear-gradient(
        var(--glass-reflex-degree, 100deg),
        rgb(255 255 255 / var(--glass-reflex-opacity, 10%)) 25%,
        rgb(0 0 0 / 0%) 25%
      );
  box-shadow: 0 0 0 1px rgb(255 255 255 / var(--glass-border-opacity, 10%)) inset,
      0 0 0 2px rgb(0 0 0 / 5%);
  text-shadow: 0 1px rgb(0 0 0 / var(--glass-text-shadow-opacity, 5%));
}
@media (hover: hover){

  .glass.btn-active{
    border: none;
    -webkit-backdrop-filter: blur(var(--glass-blur, 40px));
            backdrop-filter: blur(var(--glass-blur, 40px));
    background-color: transparent;
    background-image: linear-gradient(
          135deg,
          rgb(255 255 255 / var(--glass-opacity, 30%)) 0%,
          rgb(0 0 0 / 0%) 100%
        ),
        linear-gradient(
          var(--glass-reflex-degree, 100deg),
          rgb(255 255 255 / var(--glass-reflex-opacity, 10%)) 25%,
          rgb(0 0 0 / 0%) 25%
        );
    box-shadow: 0 0 0 1px rgb(255 255 255 / var(--glass-border-opacity, 10%)) inset,
        0 0 0 2px rgb(0 0 0 / 5%);
    text-shadow: 0 1px rgb(0 0 0 / var(--glass-text-shadow-opacity, 5%));
  }
}
.min-h-6{
  min-height: 1.5rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-16{
  min-height: 4rem;
}
.no-animation{
  --btn-focus-scale: 1;
  --animation-btn: 0;
  --animation-input: 0;
}
.tab-border-none{
  --tab-border: 0px;
}
.tab-border{
  --tab-border: 1px;
}
.tab-border-2{
  --tab-border: 2px;
}
.tab-border-3{
  --tab-border: 3px;
}
.tab-rounded-none{
  --tab-radius: 0;
}
.tab-rounded-lg{
  --tab-radius: 0.5rem;
}
.artboard-demo{
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.artboard.phone{
  width: 320px;
}
.artboard.phone-1{
  width: 320px;
  height: 568px;
}
.artboard.phone-1.horizontal,
      .artboard.phone-1.artboard-horizontal{
  width: 568px;
  height: 320px;
}
.artboard.phone-2{
  width: 375px;
  height: 667px;
}
.artboard.phone-2.horizontal,
      .artboard.phone-2.artboard-horizontal{
  width: 667px;
  height: 375px;
}
.artboard.phone-3{
  width: 414px;
  height: 736px;
}
.artboard.phone-3.horizontal,
      .artboard.phone-3.artboard-horizontal{
  width: 736px;
  height: 414px;
}
.artboard.phone-4{
  width: 375px;
  height: 812px;
}
.artboard.phone-4.horizontal,
      .artboard.phone-4.artboard-horizontal{
  width: 812px;
  height: 375px;
}
.artboard.phone-5{
  width: 414px;
  height: 896px;
}
.artboard.phone-5.horizontal,
      .artboard.phone-5.artboard-horizontal{
  width: 896px;
  height: 414px;
}
.artboard.phone-6{
  width: 320px;
  height: 1024px;
}
.artboard.phone-6.horizontal,
      .artboard.phone-6.artboard-horizontal{
  width: 1024px;
  height: 320px;
}
.badge-xs{
  height: 0.75rem;
  font-size: 0.75rem;
  line-height: .75rem;
  padding-left: 0.313rem;
  padding-right: 0.313rem;
}
.badge-sm{
  height: 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  padding-left: 0.438rem;
  padding-right: 0.438rem;
}
.badge-md{
  height: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 0.563rem;
  padding-right: 0.563rem;
}
.badge-lg{
  height: 1.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0.688rem;
  padding-right: 0.688rem;
}
.btm-nav-xs{
  height: 2.5rem;
}
.btm-nav-xs > *:where(.active){
  border-top-width: 1px;
}
.btm-nav-xs .btm-nav-label{
  font-size: 0.75rem;
  line-height: 1rem;
}
.btm-nav-sm{
  height: 3rem;
}
.btm-nav-sm > *:where(.active){
  border-top-width: 2px;
}
.btm-nav-sm .btm-nav-label{
  font-size: 0.75rem;
  line-height: 1rem;
}
.btm-nav-md{
  height: 4rem;
}
.btm-nav-md > *:where(.active){
  border-top-width: 2px;
}
.btm-nav-md .btm-nav-label{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.btm-nav-lg{
  height: 5rem;
}
.btm-nav-lg > *:where(.active){
  border-top-width: 4px;
}
.btm-nav-lg .btm-nav-label{
  font-size: 1rem;
  line-height: 1.5rem;
}
.btn-xs{
  height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  min-height: 1.5rem;
  font-size: 0.75rem;
}
.btn-sm{
  height: 2rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  min-height: 2rem;
  font-size: 0.875rem;
}
.btn-md{
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  min-height: 3rem;
  font-size: 0.875rem;
}
.btn-lg{
  height: 4rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  min-height: 4rem;
  font-size: 1.125rem;
}
.btn-wide{
  width: 16rem;
}
.btn-block{
  width: 100%;
}
.btn-square:where(.btn-xs){
  height: 1.5rem;
  width: 1.5rem;
  padding: 0px;
}
.btn-square:where(.btn-sm){
  height: 2rem;
  width: 2rem;
  padding: 0px;
}
.btn-square:where(.btn-md){
  height: 3rem;
  width: 3rem;
  padding: 0px;
}
.btn-square:where(.btn-lg){
  height: 4rem;
  width: 4rem;
  padding: 0px;
}
.btn-circle:where(.btn-xs){
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 9999px;
  padding: 0px;
}
.btn-circle:where(.btn-sm){
  height: 2rem;
  width: 2rem;
  border-radius: 9999px;
  padding: 0px;
}
.btn-circle:where(.btn-md){
  height: 3rem;
  width: 3rem;
  border-radius: 9999px;
  padding: 0px;
}
.btn-circle:where(.btn-lg){
  height: 4rem;
  width: 4rem;
  border-radius: 9999px;
  padding: 0px;
}
.btn-group-horizontal{
  flex-direction: row;
}
.btn-group-vertical{
  flex-direction: column;
}
.card-side{
  align-items: stretch;
  flex-direction: row;
}
.card-side :where(figure:first-child){
  overflow: hidden;
  border-start-start-radius: inherit;
  border-start-end-radius: unset;
  border-end-start-radius: inherit;
  border-end-end-radius: unset;
}
.card-side :where(figure:last-child){
  overflow: hidden;
  border-start-start-radius: unset;
  border-start-end-radius: inherit;
  border-end-start-radius: unset;
  border-end-end-radius: inherit;
}
.card-side figure > *{
  max-width: unset;
}
:where(.card-side figure > *){
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
.checkbox-xs{
  height: 1rem;
  width: 1rem;
}
.checkbox-sm{
  height: 1.25rem;
  width: 1.25rem;
}
.checkbox-md{
  height: 1.5rem;
  width: 1.5rem;
}
.checkbox-lg{
  height: 2rem;
  width: 2rem;
}
.divider-horizontal{
  flex-direction: column;
}
.divider-horizontal:before{
  height: 100%;
  width: 0.125rem;
}
.divider-horizontal:after{
  height: 100%;
  width: 0.125rem;
}
.divider-vertical{
  flex-direction: row;
}
.divider-vertical:before{
  height: 0.125rem;
  width: 100%;
}
.divider-vertical:after{
  height: 0.125rem;
  width: 100%;
}
.drawer-open > .drawer-toggle{
  display: none;
}
.drawer-open > .drawer-toggle ~ .drawer-side{
  pointer-events: auto;
  visibility: visible;
  position: sticky;
  display: block;
  width: auto;
  overscroll-behavior: auto;
}
.drawer-open > .drawer-toggle ~ .drawer-side > *:not(.drawer-overlay){
  transform: translateX(0%);
}
[dir="rtl"] .drawer-open > .drawer-toggle ~ .drawer-side > *:not(.drawer-overlay){
  transform: translateX(0%);
}
.drawer-open > .drawer-toggle:checked ~ .drawer-side{
  pointer-events: auto;
  visibility: visible;
}
.file-input-xs{
  height: 1.5rem;
  padding-right: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
}
.file-input-xs::file-selector-button{
  margin-right: 0.5rem;
  font-size: 0.75rem;
}
.file-input-sm{
  height: 2rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
}
.file-input-sm::file-selector-button{
  margin-right: 0.75rem;
  font-size: 0.875rem;
}
.file-input-md{
  height: 3rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
}
.file-input-md::file-selector-button{
  margin-right: 1rem;
  font-size: 0.875rem;
}
.file-input-lg{
  height: 4rem;
  padding-right: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
}
.file-input-lg::file-selector-button{
  margin-right: 1.5rem;
  font-size: 1.125rem;
}
.indicator :where(.indicator-item){
  bottom: auto;
  left: auto;
  right: 0px;
  top: 0px;
  --tw-translate-y: -50%;
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-start){
  left: 0px;
  right: auto;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-center){
  left: 50%;
  right: 50%;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-end){
  left: auto;
  right: 0px;
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-bottom){
  bottom: 0px;
  top: auto;
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-middle){
  bottom: 50%;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-top){
  bottom: auto;
  top: 0px;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.input-xs{
  height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
}
.input-md{
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
}
.input-lg{
  height: 4rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
}
.input-sm{
  height: 2rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 2rem;
}
.join.join-vertical{
  flex-direction: column;
}
.join.join-vertical .join-item:first-child:not(:last-child),
  .join.join-vertical *:first-child:not(:last-child) .join-item{
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.join.join-vertical .join-item:last-child:not(:first-child),
  .join.join-vertical *:last-child:not(:first-child) .join-item{
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.join.join-horizontal{
  flex-direction: row;
}
.join.join-horizontal .join-item:first-child:not(:last-child),
  .join.join-horizontal *:first-child:not(:last-child) .join-item{
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: inherit;
  border-top-left-radius: inherit;
}
.join.join-horizontal .join-item:last-child:not(:first-child),
  .join.join-horizontal *:last-child:not(:first-child) .join-item{
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: inherit;
  border-top-right-radius: inherit;
}
.kbd-xs{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  min-height: 1.2em;
  min-width: 1.2em;
}
.kbd-sm{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  min-height: 1.6em;
  min-width: 1.6em;
}
.kbd-md{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  min-height: 2.2em;
  min-width: 2.2em;
}
.kbd-lg{
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  min-height: 2.5em;
  min-width: 2.5em;
}
.menu-horizontal{
  display: inline-flex;
  flex-direction: row;
}
.menu-horizontal > li:not(.menu-title) > details > ul{
  position: absolute;
}
.menu-vertical{
  display: flex;
  flex-direction: column;
}
.menu-vertical > li:not(.menu-title) > details > ul{
  position: relative;
}
.modal-top{
  place-items: start;
}
.modal-middle{
  place-items: center;
}
.modal-bottom{
  place-items: end;
}
.radio-xs{
  height: 1rem;
  width: 1rem;
}
.radio-sm{
  height: 1.25rem;
  width: 1.25rem;
}
.radio-md{
  height: 1.5rem;
  width: 1.5rem;
}
.radio-lg{
  height: 2rem;
  width: 2rem;
}
.range-xs{
  height: 1rem;
}
.range-xs::-webkit-slider-runnable-track{
  height: 0.25rem;
}
.range-xs::-moz-range-track{
  height: 0.25rem;
}
.range-xs::-webkit-slider-thumb{
  height: 1rem;
  width: 1rem;
  --filler-offset: 0.4rem;
}
.range-xs::-moz-range-thumb{
  height: 1rem;
  width: 1rem;
  --filler-offset: 0.4rem;
}
.range-sm{
  height: 1.25rem;
}
.range-sm::-webkit-slider-runnable-track{
  height: 0.25rem;
}
.range-sm::-moz-range-track{
  height: 0.25rem;
}
.range-sm::-webkit-slider-thumb{
  height: 1.25rem;
  width: 1.25rem;
  --filler-offset: 0.5rem;
}
.range-sm::-moz-range-thumb{
  height: 1.25rem;
  width: 1.25rem;
  --filler-offset: 0.5rem;
}
.range-md{
  height: 1.5rem;
}
.range-md::-webkit-slider-runnable-track{
  height: 0.5rem;
}
.range-md::-moz-range-track{
  height: 0.5rem;
}
.range-md::-webkit-slider-thumb{
  height: 1.5rem;
  width: 1.5rem;
  --filler-offset: 0.6rem;
}
.range-md::-moz-range-thumb{
  height: 1.5rem;
  width: 1.5rem;
  --filler-offset: 0.6rem;
}
.range-lg{
  height: 2rem;
}
.range-lg::-webkit-slider-runnable-track{
  height: 1rem;
}
.range-lg::-moz-range-track{
  height: 1rem;
}
.range-lg::-webkit-slider-thumb{
  height: 2rem;
  width: 2rem;
  --filler-offset: 1rem;
}
.range-lg::-moz-range-thumb{
  height: 2rem;
  width: 2rem;
  --filler-offset: 1rem;
}
.rating-xs input{
  height: 0.75rem;
  width: 0.75rem;
}
.rating-sm input{
  height: 1rem;
  width: 1rem;
}
.rating-md input{
  height: 1.5rem;
  width: 1.5rem;
}
.rating-lg input{
  height: 2.5rem;
  width: 2.5rem;
}
.rating-half.rating-xs input:not(.rating-hidden){
  width: 0.375rem;
}
.rating-half.rating-sm input:not(.rating-hidden){
  width: 0.5rem;
}
.rating-half.rating-md input:not(.rating-hidden){
  width: 0.75rem;
}
.rating-half.rating-lg input:not(.rating-hidden){
  width: 1.25rem;
}
.select-md{
  height: 3rem;
  padding-left: 1rem;
  padding-right: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  min-height: 3rem;
}
[dir="rtl"] .select-md{
  padding-left: 2.5rem;
  padding-right: 1rem;
}
.select-lg{
  height: 4rem;
  padding-left: 1.5rem;
  padding-right: 2rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
  min-height: 4rem;
}
[dir="rtl"] .select-lg{
  padding-left: 2rem;
  padding-right: 1.5rem;
}
.select-sm{
  height: 2rem;
  padding-left: 0.75rem;
  padding-right: 2rem;
  font-size: 0.875rem;
  line-height: 2rem;
  min-height: 2rem;
}
[dir="rtl"] .select-sm{
  padding-left: 2rem;
  padding-right: 0.75rem;
}
.select-xs{
  height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 2rem;
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
  min-height: 1.5rem;
}
[dir="rtl"] .select-xs{
  padding-left: 2rem;
  padding-right: 0.5rem;
}
.stats-horizontal{
  grid-auto-flow: column;
}
.stats-vertical{
  grid-auto-flow: row;
}
.steps-horizontal{
  grid-auto-columns: 1fr;
  display: inline-grid;
  grid-auto-flow: column;
  overflow: hidden;
  overflow-x: auto;
}
.steps-horizontal .step{
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  place-items: center;
  text-align: center;
}
.steps-vertical{
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
}
.steps-vertical .step{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.tab-md{
  height: 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  --tab-padding: 1rem;
}
.tab-lg{
  height: 3rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
  --tab-padding: 1.25rem;
}
.tab-sm{
  height: 1.5rem;
  font-size: 0.875rem;
  line-height: .75rem;
  --tab-padding: 0.75rem;
}
.tab-xs{
  height: 1.25rem;
  font-size: 0.75rem;
  line-height: .75rem;
  --tab-padding: 0.5rem;
}
.textarea-xs{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
}
.textarea-sm{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 2rem;
}
.textarea-md{
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
}
.textarea-lg{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
}
:where(.toast){
  bottom: 0px;
  left: auto;
  right: 0px;
  top: auto;
  --tw-translate-x: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-start){
  left: 0px;
  right: auto;
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-center){
  left: 50%;
  right: 50%;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-end){
  left: auto;
  right: 0px;
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-bottom){
  bottom: 0px;
  top: auto;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-middle){
  bottom: auto;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-top){
  bottom: auto;
  top: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toggle-xs{
  --handleoffset: 0.5rem;
  height: 1rem;
  width: 1.5rem;
}
.toggle-sm{
  --handleoffset: 0.75rem;
  height: 1.25rem;
  width: 2rem;
}
.toggle-md{
  --handleoffset: 1.5rem;
  height: 1.5rem;
  width: 3rem;
}
.toggle-lg{
  --handleoffset: 2rem;
  height: 2rem;
  width: 4rem;
}
.tooltip{
  position: relative;
  display: inline-block;
  --tooltip-offset: calc(100% + 1px + var(--tooltip-tail, 0px));
}
.tooltip:before{
  position: absolute;
  pointer-events: none;
  z-index: 1;
  content: var(--tw-content);
  --tw-content: attr(data-tip);
}
.tooltip:before, .tooltip-top:before{
  transform: translateX(-50%);
  top: auto;
  left: 50%;
  right: auto;
  bottom: var(--tooltip-offset);
}
.tooltip-bottom:before{
  transform: translateX(-50%);
  top: var(--tooltip-offset);
  left: 50%;
  right: auto;
  bottom: auto;
}
.tooltip-left:before{
  transform: translateY(-50%);
  top: 50%;
  left: auto;
  right: var(--tooltip-offset);
  bottom: auto;
}
.tooltip-right:before{
  transform: translateY(-50%);
  top: 50%;
  left: var(--tooltip-offset);
  right: auto;
  bottom: auto;
}
.artboard-demo{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: hsl(var(--bc) / var(--tw-text-opacity));
  border-radius: var(--rounded-box, 1rem);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.avatar.online:before{
  content: "";
  position: absolute;
  z-index: 10;
  display: block;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
  outline-style: solid;
  outline-width: 2px;
  outline-color: hsl(var(--b1) / 1);
  width: 15%;
  height: 15%;
  top: 7%;
  right: 7%;
}
.avatar.offline:before{
  content: "";
  position: absolute;
  z-index: 10;
  display: block;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  outline-style: solid;
  outline-width: 2px;
  outline-color: hsl(var(--b1) / 1);
  width: 15%;
  height: 15%;
  top: 7%;
  right: 7%;
}
.btn-group .btn:not(:first-child):not(:last-child){
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group .btn:first-child:not(:last-child){
  margin-left: -1px;
  margin-top: -0px;
  border-top-left-radius: var(--rounded-btn, 0.5rem);
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--rounded-btn, 0.5rem);
  border-bottom-right-radius: 0;
}
.btn-group .btn:last-child:not(:first-child){
  border-top-left-radius: 0;
  border-top-right-radius: var(--rounded-btn, 0.5rem);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: var(--rounded-btn, 0.5rem);
}
.btn-group-horizontal .btn:not(:first-child):not(:last-child){
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group-horizontal .btn:first-child:not(:last-child){
  margin-left: -1px;
  margin-top: -0px;
  border-top-left-radius: var(--rounded-btn, 0.5rem);
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--rounded-btn, 0.5rem);
  border-bottom-right-radius: 0;
}
.btn-group-horizontal .btn:last-child:not(:first-child){
  border-top-left-radius: 0;
  border-top-right-radius: var(--rounded-btn, 0.5rem);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: var(--rounded-btn, 0.5rem);
}
.btn-group-vertical .btn:first-child:not(:last-child){
  margin-left: -0px;
  margin-top: -1px;
  border-top-left-radius: var(--rounded-btn, 0.5rem);
  border-top-right-radius: var(--rounded-btn, 0.5rem);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group-vertical .btn:last-child:not(:first-child){
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: var(--rounded-btn, 0.5rem);
  border-bottom-right-radius: var(--rounded-btn, 0.5rem);
}
.card-compact .card-body{
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.card-compact .card-title{
  margin-bottom: 0.25rem;
}
.card-normal .card-body{
  padding: var(--padding-card, 2rem);
  font-size: 1rem;
  line-height: 1.5rem;
}
.card-normal .card-title{
  margin-bottom: 0.75rem;
}
.divider-horizontal{
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 0px;
  margin-bottom: 0px;
  height: auto;
  width: 1rem;
}
.divider-vertical{
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1rem;
  width: auto;
}
.drawer-open > .drawer-toggle ~ .drawer-side > .drawer-overlay{
  cursor: default;
  background-color: transparent;
}
.join.join-vertical > :where(*:not(:first-child)){
  margin-left: 0px;
  margin-right: 0px;
  margin-top: -1px;
}
.join.join-horizontal > :where(*:not(:first-child)){
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: -1px;
}
.menu-horizontal > li:not(.menu-title) > details > ul{
  margin-left: 0px;
  margin-top: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 0.5rem;
}
.menu-horizontal > li > details > ul:before{
  content: none;
}
:where(.menu-horizontal > li:not(.menu-title) > details > ul){
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: var(--rounded-box, 1rem);
}
.menu-vertical > li:not(.menu-title) > details > ul{
  margin-left: 1rem;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
}
.menu-xs :where(li:not(.menu-title) > *:not(ul):not(details):not(.menu-title)),
  .menu-xs :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  border-radius: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
}
.menu-xs .menu-title{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.menu-sm :where(li:not(.menu-title) > *:not(ul):not(details):not(.menu-title)),
  .menu-sm :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-radius: var(--rounded-btn, 0.5rem);
}
.menu-sm .menu-title{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.menu-md :where(li:not(.menu-title) > *:not(ul):not(details):not(.menu-title)),
  .menu-md :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-radius: var(--rounded-btn, 0.5rem);
}
.menu-md .menu-title{
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.menu-lg :where(li:not(.menu-title) > *:not(ul):not(details):not(.menu-title)),
  .menu-lg :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  border-radius: var(--rounded-btn, 0.5rem);
}
.menu-lg .menu-title{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.modal-top :where(.modal-box){
  width: 100%;
  max-width: none;
  --tw-translate-y: -2.5rem;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: var(--rounded-box, 1rem);
}
.modal-middle :where(.modal-box){
  width: 91.666667%;
  max-width: 32rem;
  --tw-translate-y: 0px;
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
  border-bottom-left-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: var(--rounded-box, 1rem);
}
.modal-bottom :where(.modal-box){
  width: 100%;
  max-width: none;
  --tw-translate-y: 2.5rem;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
}
.stats-horizontal > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  --tw-divide-y-reverse: 0;
  border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
}
.stats-horizontal{
  overflow-x: auto;
}
.stats-vertical > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(0px * var(--tw-divide-x-reverse));
  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)));
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.stats-vertical{
  overflow-y: auto;
}
.steps-horizontal .step{
  grid-template-rows: 40px 1fr;
  grid-template-columns: auto;
  min-width: 4rem;
}
.steps-horizontal .step:before{
  height: 0.5rem;
  width: 100%;
  --tw-translate-x: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  content: "";
  margin-left: -100%;
}
.steps-vertical .step{
  gap: 0.5rem;
  grid-template-columns: 40px 1fr;
  grid-template-rows: auto;
  min-height: 4rem;
  justify-items: start;
}
.steps-vertical .step:before{
  height: 100%;
  width: 0.5rem;
  --tw-translate-x: -50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  margin-left: 50%;
}
[dir="rtl"] .steps-vertical .step:before{
  margin-right: auto;
}
.table-xs :not(thead):not(tfoot) tr{
  font-size: 0.75rem;
  line-height: 1rem;
}
.table-xs :where(th, td){
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.table-sm :not(thead):not(tfoot) tr{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.table-sm :where(th, td){
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.table-md :not(thead):not(tfoot) tr{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.table-md :where(th, td){
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.table-lg :not(thead):not(tfoot) tr{
  font-size: 1rem;
  line-height: 1.5rem;
}
.table-lg :where(th, td){
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.tooltip{
  position: relative;
  display: inline-block;
  text-align: center;
  --tooltip-tail: 0.1875rem;
  --tooltip-color: hsl(var(--n));
  --tooltip-text-color: hsl(var(--nc));
  --tooltip-tail-offset: calc(100% + 0.0625rem - var(--tooltip-tail));
}
.tooltip:before,
.tooltip:after{
  opacity: 0;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-delay: 100ms;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.tooltip:after{
  position: absolute;
  content: "";
  border-style: solid;
  border-width: var(--tooltip-tail, 0);
  width: 0;
  height: 0;
  display: block;
}
.tooltip:before{
  max-width: 20rem;
  border-radius: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background-color: var(--tooltip-color);
  color: var(--tooltip-text-color);
  width: -moz-max-content;
  width: max-content;
}
.tooltip.tooltip-open:before,
.tooltip.tooltip-open:after,
.tooltip:hover:before,
.tooltip:hover:after{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip:has(:focus-visible):after,
.tooltip:has(:focus-visible):before{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip:not([data-tip]):hover:before,
.tooltip:not([data-tip]):hover:after{
  visibility: hidden;
  opacity: 0;
}
.tooltip:after, .tooltip-top:after{
  transform: translateX(-50%);
  border-color: var(--tooltip-color) transparent transparent transparent;
  top: auto;
  left: 50%;
  right: auto;
  bottom: var(--tooltip-tail-offset);
}
.tooltip-bottom:after{
  transform: translateX(-50%);
  border-color: transparent transparent var(--tooltip-color) transparent;
  top: var(--tooltip-tail-offset);
  left: 50%;
  right: auto;
  bottom: auto;
}
.tooltip-left:after{
  transform: translateY(-50%);
  border-color: transparent transparent transparent var(--tooltip-color);
  top: 50%;
  left: auto;
  right: calc(var(--tooltip-tail-offset) + 0.0625rem);
  bottom: auto;
}
.tooltip-right:after{
  transform: translateY(-50%);
  border-color: transparent var(--tooltip-color) transparent transparent;
  top: 50%;
  left: calc(var(--tooltip-tail-offset) + 0.0625rem);
  right: auto;
  bottom: auto;
}
.tooltip-primary{
  --tooltip-color: hsl(var(--p));
  --tooltip-text-color: hsl(var(--pc));
}
.tooltip-secondary{
  --tooltip-color: hsl(var(--s));
  --tooltip-text-color: hsl(var(--sc));
}
.tooltip-accent{
  --tooltip-color: hsl(var(--a));
  --tooltip-text-color: hsl(var(--ac));
}
.tooltip-info{
  --tooltip-color: hsl(var(--in));
  --tooltip-text-color: hsl(var(--inc));
}
.tooltip-success{
  --tooltip-color: hsl(var(--su));
  --tooltip-text-color: hsl(var(--suc));
}
.tooltip-warning{
  --tooltip-color: hsl(var(--wa));
  --tooltip-text-color: hsl(var(--wac));
}
.tooltip-error{
  --tooltip-color: hsl(var(--er));
  --tooltip-text-color: hsl(var(--erc));
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.not-sr-only{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-1{
  inset: -0.25rem;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-right-2{
  right: -0.5rem;
}
.-right-5{
  right: -1.25rem;
}
.-right-6{
  right: -1.5rem;
}
.-right-\\[1\\%\\]{
  right: -1%;
}
.-right-\\[30\\%\\]{
  right: -30%;
}
.-top-1{
  top: -0.25rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.left-0{
  left: 0px;
}
.left-3{
  left: 0.75rem;
}
.left-5{
  left: 1.25rem;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-10{
  right: 2.5rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-5{
  right: 1.25rem;
}
.right-\\[80px\\]{
  right: 80px;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-8{
  top: 2rem;
}
.top-\\[10px\\]{
  top: 10px;
}
.isolate{
  isolation: isolate;
}
.isolation-auto{
  isolation: auto;
}
.-z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[999\\]{
  z-index: 999;
}
.z-\\[99\\]{
  z-index: 99;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-7{
  grid-column: span 7 / span 7;
}
.col-span-8{
  grid-column: span 8 / span 8;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-2{
  margin: 0.5rem;
}
.m-4{
  margin: 1rem;
}
.m-5{
  margin: 1.25rem;
}
.m-8{
  margin: 2rem;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mb-4{
  margin-bottom: -1rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-14{
  margin-right: -3.5rem;
}
.-mr-16{
  margin-right: -4rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.-mt-\\[1px\\]{
  margin-top: -1px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-11{
  margin-bottom: 2.75rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-32{
  margin-bottom: 8rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-\\[1px\\]{
  margin-left: 1px;
}
.ml-\\[1rem\\]{
  margin-left: 1rem;
}
.ml-\\[2px\\]{
  margin-left: 2px;
}
.ml-\\[45px\\]{
  margin-left: 45px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-0{
  margin-top: 0px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[2px\\]{
  margin-top: 2px;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.inline-table{
  display: inline-table;
}
.table-caption{
  display: table-caption;
}
.table-cell{
  display: table-cell;
}
.table-column{
  display: table-column;
}
.table-column-group{
  display: table-column-group;
}
.table-footer-group{
  display: table-footer-group;
}
.table-header-group{
  display: table-header-group;
}
.table-row-group{
  display: table-row-group;
}
.table-row{
  display: table-row;
}
.flow-root{
  display: flow-root;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.contents{
  display: contents;
}
.list-item{
  display: list-item;
}
.hidden{
  display: none;
}
.h-0{
  height: 0px;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-60{
  height: 15rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-\\[1\\.5px\\]{
  height: 1.5px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[23px\\]{
  height: 23px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[6px\\]{
  height: 6px;
}
.h-\\[75px\\]{
  height: 75px;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[calc\\(100vh-200px\\)\\]{
  height: calc(100vh - 200px);
}
.h-\\[calc\\(100vh-300px\\)\\]{
  height: calc(100vh - 300px);
}
.h-\\[calc\\(auto-1rem\\)\\]{
  height: calc(auto - 1rem);
}
.h-auto{
  height: auto;
}
.h-fit{
  height: -moz-fit-content;
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[148px\\]{
  max-height: 148px;
}
.max-h-\\[60\\%\\]{
  max-height: 60%;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[80px\\]{
  max-height: 80px;
}
.max-h-\\[calc\\(100vh-220px\\)\\]{
  max-height: calc(100vh - 220px);
}
.max-h-\\[calc\\(100vh-240px\\)\\]{
  max-height: calc(100vh - 240px);
}
.max-h-\\[calc\\(100vh-350px\\)\\]{
  max-height: calc(100vh - 350px);
}
.max-h-full{
  max-height: 100%;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-16{
  min-height: 4rem;
}
.min-h-6{
  min-height: 1.5rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-240px\\)\\]{
  min-height: calc(100vh - 240px);
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-8{
  width: 2rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[122px\\]{
  width: 122px;
}
.w-\\[126px\\]{
  width: 126px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[222px\\]{
  width: 222px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[463px\\]{
  width: 463px;
}
.w-\\[479px\\]{
  width: 479px;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[550px\\]{
  width: 550px;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[6px\\]{
  width: 6px;
}
.w-\\[75\\%\\]{
  width: 75%;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[400px\\]{
  min-width: 400px;
}
.min-w-\\[65\\%\\]{
  min-width: 65%;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-full{
  min-width: 100%;
}
.min-w-max{
  min-width: -moz-max-content;
  min-width: max-content;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[50vh\\]{
  max-width: 50vh;
}
.max-w-\\[75\\%\\]{
  max-width: 75%;
}
.max-w-\\[80px\\]{
  max-width: 80px;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-fit{
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-initial{
  flex: 0 1 auto;
}
.flex-none{
  flex: none;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-180{
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-\\[-1\\]{
  --tw-scale-y: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.\\!cursor-pointer{
  cursor: pointer !important;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.content-center{
  align-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-11{
  gap: 2.75rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-1{
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.gap-x-2{
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-4{
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-y-0{
  row-gap: 0px;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.-space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 1;
}
.space-x-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 1;
}
.divide-x-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 1;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.text-clip{
  text-overflow: clip;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.whitespace-break-spaces{
  white-space: break-spaces;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.\\!rounded-b-none{
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.rounded-b{
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-md{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-e{
  border-start-end-radius: 0.25rem;
  border-end-end-radius: 0.25rem;
}
.rounded-e-3xl{
  border-start-end-radius: 1.5rem;
  border-end-end-radius: 1.5rem;
}
.rounded-e-md{
  border-start-end-radius: 0.375rem;
  border-end-end-radius: 0.375rem;
}
.rounded-l{
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-3xl{
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-3xl{
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
.rounded-s{
  border-start-start-radius: 0.25rem;
  border-end-start-radius: 0.25rem;
}
.rounded-s-3xl{
  border-start-start-radius: 1.5rem;
  border-end-start-radius: 1.5rem;
}
.rounded-s-md{
  border-start-start-radius: 0.375rem;
  border-end-start-radius: 0.375rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md{
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-bl{
  border-bottom-left-radius: 0.25rem;
}
.rounded-bl-2xl{
  border-bottom-left-radius: 1rem;
}
.rounded-bl-\\[10px\\]{
  border-bottom-left-radius: 10px;
}
.rounded-br{
  border-bottom-right-radius: 0.25rem;
}
.rounded-br-2xl{
  border-bottom-right-radius: 1rem;
}
.rounded-br-\\[10px\\]{
  border-bottom-right-radius: 10px;
}
.rounded-ee{
  border-end-end-radius: 0.25rem;
}
.rounded-es{
  border-end-start-radius: 0.25rem;
}
.rounded-se{
  border-start-end-radius: 0.25rem;
}
.rounded-ss{
  border-start-start-radius: 0.25rem;
}
.rounded-tl{
  border-top-left-radius: 0.25rem;
}
.rounded-tl-2xl{
  border-top-left-radius: 1rem;
}
.rounded-tl-lg{
  border-top-left-radius: 0.5rem;
}
.rounded-tl-xl{
  border-top-left-radius: 0.75rem;
}
.rounded-tr{
  border-top-right-radius: 0.25rem;
}
.rounded-tr-lg{
  border-top-right-radius: 0.5rem;
}
.rounded-tr-xl{
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-4{
  border-bottom-width: 4px;
}
.border-e{
  border-inline-end-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-s{
  border-inline-start-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.border-dotted{
  border-style: dotted;
}
.border-none{
  border-style: none;
}
.border-\\[\\#0b99b2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(11 153 178 / var(--tw-border-opacity));
}
.border-\\[\\#31c178\\]{
  --tw-border-opacity: 1;
  border-color: rgb(49 193 120 / var(--tw-border-opacity));
}
.border-\\[\\#93C5FD\\]{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.border-\\[\\#94A3B8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity));
}
.border-\\[\\#99ff99\\]{
  --tw-border-opacity: 1;
  border-color: rgb(153 255 153 / var(--tw-border-opacity));
}
.border-\\[\\#C084F4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 244 / var(--tw-border-opacity));
}
.border-\\[\\#C7C7C7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(199 199 199 / var(--tw-border-opacity));
}
.border-\\[\\#D81B60\\]{
  --tw-border-opacity: 1;
  border-color: rgb(216 27 96 / var(--tw-border-opacity));
}
.border-\\[\\#D9DEE8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 222 232 / var(--tw-border-opacity));
}
.border-\\[\\#E047\\]{
  border-color: #E047;
}
.border-\\[\\#E3E3E3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(227 227 227 / var(--tw-border-opacity));
}
.border-\\[\\#FCA5A5\\]{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.border-\\[\\#FDE047\\]{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}
.border-accent{
  --tw-border-opacity: 1;
  border-color: hsl(var(--a) / var(--tw-border-opacity));
}
.border-base-100{
  --tw-border-opacity: 1;
  border-color: hsl(var(--b1) / var(--tw-border-opacity));
}
.border-base-200{
  --tw-border-opacity: 1;
  border-color: hsl(var(--b2) / var(--tw-border-opacity));
}
.border-base-300{
  --tw-border-opacity: 1;
  border-color: hsl(var(--b3) / var(--tw-border-opacity));
}
.border-begoniaRed{
  --tw-border-opacity: 1;
  border-color: rgb(255 113 113 / var(--tw-border-opacity));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-brightGray{
  --tw-border-opacity: 1;
  border-color: rgb(234 236 240 / var(--tw-border-opacity));
}
.border-chineseSilver{
  --tw-border-opacity: 1;
  border-color: rgb(199 199 199 / var(--tw-border-opacity));
}
.border-error{
  --tw-border-opacity: 1;
  border-color: hsl(var(--er) / var(--tw-border-opacity));
}
.border-gainsboroBlue{
  --tw-border-opacity: 1;
  border-color: rgb(217 222 232 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.border-independenceBlue{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 116 / var(--tw-border-opacity));
}
.border-info{
  --tw-border-opacity: 1;
  border-color: hsl(var(--in) / var(--tw-border-opacity));
}
.border-neutral{
  --tw-border-opacity: 1;
  border-color: hsl(var(--n) / var(--tw-border-opacity));
}
.border-northTexasGreen{
  --tw-border-opacity: 1;
  border-color: rgb(0 169 37 / var(--tw-border-opacity));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: rgb(25 42 81 / var(--tw-border-opacity));
}
.border-quickSilver{
  --tw-border-opacity: 1;
  border-color: rgb(159 159 159 / var(--tw-border-opacity));
}
.border-rasinBlack{
  --tw-border-opacity: 1;
  border-color: rgb(38 37 37 / var(--tw-border-opacity));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-secondary{
  --tw-border-opacity: 1;
  border-color: rgb(244 244 244 / var(--tw-border-opacity));
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}
.border-spaceCadetBlue{
  --tw-border-opacity: 1;
  border-color: rgb(25 42 81 / var(--tw-border-opacity));
}
.border-success{
  --tw-border-opacity: 1;
  border-color: hsl(var(--su) / var(--tw-border-opacity));
}
.border-warning{
  --tw-border-opacity: 1;
  border-color: hsl(var(--wa) / var(--tw-border-opacity));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\!bg-blue-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity)) !important;
}
.\\!bg-green-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;
}
.\\!bg-red-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}
.\\!bg-spaceCadetBlue{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#0B99B2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 153 178 / var(--tw-bg-opacity));
}
.bg-\\[\\#31c178\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(49 193 120 / var(--tw-bg-opacity));
}
.bg-\\[\\#435171\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(67 81 113 / var(--tw-bg-opacity));
}
.bg-\\[\\#C4E5B6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(196 229 182 / var(--tw-bg-opacity));
}
.bg-\\[\\#EAECF0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity));
}
.bg-\\[\\#F4F4F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9FEFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 254 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#FBFBFB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFE249\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 226 73 / var(--tw-bg-opacity));
}
.bg-\\[\\#ccc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(204 204 204 / var(--tw-bg-opacity));
}
.bg-\\[\\#de2626\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(222 38 38 / var(--tw-bg-opacity));
}
.bg-\\[\\#e4e4e5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 229 / var(--tw-bg-opacity));
}
.bg-\\[\\#e5fff2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 255 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#e8f6f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 246 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#f7f7f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 249 / var(--tw-bg-opacity));
}
.bg-accent{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--a) / var(--tw-bg-opacity));
}
.bg-aliceBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 255 / var(--tw-bg-opacity));
}
.bg-base-100{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b1) / var(--tw-bg-opacity));
}
.bg-base-200{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
}
.bg-base-300{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--b3) / var(--tw-bg-opacity));
}
.bg-begoniaRed{
  --tw-bg-opacity: 1;
  background-color: rgb(255 113 113 / var(--tw-bg-opacity));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.bg-blue-dark{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 116 / var(--tw-bg-opacity));
}
.bg-brightGray{
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity));
}
.bg-chineseSilver{
  --tw-bg-opacity: 1;
  background-color: rgb(199 199 199 / var(--tw-bg-opacity));
}
.bg-coralRed{
  --tw-bg-opacity: 1;
  background-color: rgb(243 63 63 / var(--tw-bg-opacity));
}
.bg-culturedGray{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
}
.bg-error{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--er) / var(--tw-bg-opacity));
}
.bg-gainsboroBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(217 222 232 / var(--tw-bg-opacity));
}
.bg-gargoyleGasYellow{
  --tw-bg-opacity: 1;
  background-color: rgb(255 226 73 / var(--tw-bg-opacity));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.bg-green-300{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.bg-honeydew{
  --tw-bg-opacity: 1;
  background-color: rgb(246 255 242 / var(--tw-bg-opacity));
}
.bg-independenceBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 116 / var(--tw-bg-opacity));
}
.bg-info{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--in) / var(--tw-bg-opacity));
}
.bg-lotionLightGray{
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 251 / var(--tw-bg-opacity));
}
.bg-milkGreen{
  --tw-bg-opacity: 1;
  background-color: rgb(251 255 242 / var(--tw-bg-opacity));
}
.bg-neutral{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--n) / var(--tw-bg-opacity));
}
.bg-neutral-focus{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--nf) / var(--tw-bg-opacity));
}
.bg-northTexasGreen{
  --tw-bg-opacity: 1;
  background-color: rgb(0 169 37 / var(--tw-bg-opacity));
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity));
}
.bg-pink-300{
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
}
.bg-purple-300{
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity));
}
.bg-quickSilver{
  --tw-bg-opacity: 1;
  background-color: rgb(159 159 159 / var(--tw-bg-opacity));
}
.bg-red-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-secondary{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-spaceCadetBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
}
.bg-spaceCadetBlue80{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 116 / var(--tw-bg-opacity));
}
.bg-statusRed{
  --tw-bg-opacity: 1;
  background-color: rgb(231 49 71 / var(--tw-bg-opacity));
}
.bg-success{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--su) / var(--tw-bg-opacity));
}
.bg-transparent{
  background-color: transparent;
}
.bg-warning{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--wa) / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-yellow-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-none{
  background-image: none;
}
.from-white{
  --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-gray-100{
  --tw-gradient-to: rgb(243 244 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f3f4f6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-gray-200{
  --tw-gradient-to: #e5e7eb var(--tw-gradient-to-position);
}
.bg-repeat{
  background-repeat: repeat;
}
.fill-slate-300{
  fill: #cbd5e1;
}
.stroke-current{
  stroke: currentColor;
}
.stroke-independenceBlue{
  stroke: #475574;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-20{
  padding: 5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[15px\\]{
  padding: 15px;
}
.p-\\[27px\\]{
  padding: 27px;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[35px\\]{
  padding-left: 35px;
  padding-right: 35px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[14px\\]{
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[15px\\]{
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[1vh\\]{
  padding-top: 1vh;
  padding-bottom: 1vh;
}
.py-\\[21px\\]{
  padding-top: 21px;
  padding-bottom: 21px;
}
.py-\\[25px\\]{
  padding-top: 25px;
  padding-bottom: 25px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[5px\\]{
  padding-bottom: 5px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[10px\\]{
  padding-left: 10px;
}
.pl-\\[15px\\]{
  padding-left: 15px;
}
.pl-\\[18px\\]{
  padding-left: 18px;
}
.pl-\\[20px\\]{
  padding-left: 20px;
}
.pl-\\[21px\\]{
  padding-left: 21px;
}
.pl-\\[5px\\]{
  padding-left: 5px;
}
.pr-0{
  padding-right: 0px;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[15px\\]{
  padding-right: 15px;
}
.pr-\\[18px\\]{
  padding-right: 18px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.align-top{
  vertical-align: top;
}
.font-lato{
  font-family: Roboto;
}
.font-ptScanCap{
  font-family: PT Sans Caption;
}
.font-workSans{
  font-family: Work Sans;
}
.text-2xl{
  font-size: 1.5rem;
}
.text-3xl{
  font-size: 1.875rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[0\\.9rem\\]{
  font-size: 0.9rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
}
.text-lg{
  font-size: 1.125rem;
}
.text-sm{
  font-size: 0.875rem;
}
.text-xl{
  font-size: 1.25rem;
}
.text-xs{
  font-size: 0.75rem;
}
.text-xss{
  font-size: 0.6rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.normal-nums{
  font-variant-numeric: normal;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.slashed-zero{
  --tw-slashed-zero: slashed-zero;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.lining-nums{
  --tw-numeric-figure: lining-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.oldstyle-nums{
  --tw-numeric-figure: oldstyle-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.proportional-nums{
  --tw-numeric-spacing: proportional-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.diagonal-fractions{
  --tw-numeric-fraction: diagonal-fractions;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-none{
  line-height: 1;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.text-\\[\\#000000a3\\]{
  color: #000000a3;
}
.text-\\[\\#003249\\]{
  --tw-text-opacity: 1;
  color: rgb(0 50 73 / var(--tw-text-opacity));
}
.text-\\[\\#00a851\\]{
  --tw-text-opacity: 1;
  color: rgb(0 168 81 / var(--tw-text-opacity));
}
.text-\\[\\#0B99B2\\]{
  --tw-text-opacity: 1;
  color: rgb(11 153 178 / var(--tw-text-opacity));
}
.text-\\[\\#0b99b2\\]{
  --tw-text-opacity: 1;
  color: rgb(11 153 178 / var(--tw-text-opacity));
}
.text-\\[\\#333333\\]{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-\\[\\#52b7c9\\]{
  --tw-text-opacity: 1;
  color: rgb(82 183 201 / var(--tw-text-opacity));
}
.text-\\[\\#5c6a70\\]{
  --tw-text-opacity: 1;
  color: rgb(92 106 112 / var(--tw-text-opacity));
}
.text-\\[\\#979797\\]{
  --tw-text-opacity: 1;
  color: rgb(151 151 151 / var(--tw-text-opacity));
}
.text-\\[\\#9c9c9b\\]{
  --tw-text-opacity: 1;
  color: rgb(156 156 155 / var(--tw-text-opacity));
}
.text-\\[\\#AAA\\]{
  --tw-text-opacity: 1;
  color: rgb(170 170 170 / var(--tw-text-opacity));
}
.text-accent{
  --tw-text-opacity: 1;
  color: hsl(var(--a) / var(--tw-text-opacity));
}
.text-accent-content{
  --tw-text-opacity: 1;
  color: hsl(var(--ac) / var(--tw-text-opacity));
}
.text-begoniaRed{
  --tw-text-opacity: 1;
  color: rgb(255 113 113 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-error{
  --tw-text-opacity: 1;
  color: hsl(var(--er) / var(--tw-text-opacity));
}
.text-error-content{
  --tw-text-opacity: 1;
  color: hsl(var(--erc) / var(--tw-text-opacity));
}
.text-gainsboroBlue{
  --tw-text-opacity: 1;
  color: rgb(217 222 232 / var(--tw-text-opacity));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-independenceBlue{
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
}
.text-info{
  --tw-text-opacity: 1;
  color: hsl(var(--in) / var(--tw-text-opacity));
}
.text-info-content{
  --tw-text-opacity: 1;
  color: hsl(var(--inc) / var(--tw-text-opacity));
}
.text-neutral{
  --tw-text-opacity: 1;
  color: hsl(var(--n) / var(--tw-text-opacity));
}
.text-neutral-500{
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.text-neutral-content{
  --tw-text-opacity: 1;
  color: hsl(var(--nc) / var(--tw-text-opacity));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(25 42 81 / var(--tw-text-opacity));
}
.text-primary-content{
  --tw-text-opacity: 1;
  color: hsl(var(--pc) / var(--tw-text-opacity));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.text-quickSilver{
  --tw-text-opacity: 1;
  color: rgb(159 159 159 / var(--tw-text-opacity));
}
.text-rasinBlack{
  --tw-text-opacity: 1;
  color: rgb(38 37 37 / var(--tw-text-opacity));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.text-secondary{
  --tw-text-opacity: 1;
  color: rgb(244 244 244 / var(--tw-text-opacity));
}
.text-secondary-content{
  --tw-text-opacity: 1;
  color: hsl(var(--sc) / var(--tw-text-opacity));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-spaceCadetBlue{
  --tw-text-opacity: 1;
  color: rgb(25 42 81 / var(--tw-text-opacity));
}
.text-stone-500{
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity));
}
.text-success{
  --tw-text-opacity: 1;
  color: hsl(var(--su) / var(--tw-text-opacity));
}
.text-success-content{
  --tw-text-opacity: 1;
  color: hsl(var(--suc) / var(--tw-text-opacity));
}
.text-warning{
  --tw-text-opacity: 1;
  color: hsl(var(--wa) / var(--tw-text-opacity));
}
.text-warning-content{
  --tw-text-opacity: 1;
  color: hsl(var(--wac) / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.underline{
  text-decoration-line: underline;
}
.overline{
  text-decoration-line: overline;
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subpixel-antialiased{
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.opacity-0{
  opacity: 0;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-offset-0{
  outline-offset: 0px;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-accent{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--a) / var(--tw-ring-opacity));
}
.ring-error{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--er) / var(--tw-ring-opacity));
}
.ring-info{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--in) / var(--tw-ring-opacity));
}
.ring-neutral{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--n) / var(--tw-ring-opacity));
}
.ring-primary{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(25 42 81 / var(--tw-ring-opacity));
}
.ring-secondary{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 244 244 / var(--tw-ring-opacity));
}
.ring-success{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--su) / var(--tw-ring-opacity));
}
.ring-warning{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--wa) / var(--tw-ring-opacity));
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-base-100{
  --tw-ring-offset-color: hsl(var(--b1) / 1);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg{
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-xl{
  --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-grayscale{
  --tw-backdrop-grayscale: grayscale(100%);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-invert{
  --tw-backdrop-invert: invert(100%);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-sepia{
  --tw-backdrop-sepia: sepia(100%);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.page-private_layouts__container {
  display: grid;
  grid-template-columns: 20% 80%;
}

@media (hover:hover){

  .table .hover\\:hover:hovertr:hover,
  .table .hover\\:hover:hovertr:nth-child(even):hover{
    --tw-bg-opacity: 1;
    background-color: hsl(var(--b2) / var(--tw-bg-opacity));
  }

  .table-zebra .hover\\:hover:hovertr:hover,
  .table-zebra .hover\\:hover:hovertr:nth-child(even):hover{
    --tw-bg-opacity: 1;
    background-color: hsl(var(--b3) / var(--tw-bg-opacity));
  }
}

@media (min-width: 375px){

  .xs\\:card-side{
    align-items: stretch;
    flex-direction: row;
  }

  .xs\\:card-side :where(figure:first-child){
    overflow: hidden;
    border-start-start-radius: inherit;
    border-start-end-radius: unset;
    border-end-start-radius: inherit;
    border-end-end-radius: unset;
  }

  .xs\\:card-side :where(figure:last-child){
    overflow: hidden;
    border-start-start-radius: unset;
    border-start-end-radius: inherit;
    border-end-start-radius: unset;
    border-end-end-radius: inherit;
  }

  .xs\\:card-side figure > *{
    max-width: unset;
  }

  :where(.xs\\:card-side figure > *){
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
  }

  .xs\\:card-compact .card-body{
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .xs\\:card-compact .card-title{
    margin-bottom: 0.25rem;
  }

  .xs\\:card-normal .card-body{
    padding: var(--padding-card, 2rem);
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xs\\:card-normal .card-title{
    margin-bottom: 0.75rem;
  }
}

@media (min-width: 425px){

  .sm\\:btn-sm{
    height: 2rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    min-height: 2rem;
    font-size: 0.875rem;
  }

  .btn-square:where(.sm\\:btn-sm){
    height: 2rem;
    width: 2rem;
    padding: 0px;
  }

  .btn-circle:where(.sm\\:btn-sm){
    height: 2rem;
    width: 2rem;
    border-radius: 9999px;
    padding: 0px;
  }

  .sm\\:card-side{
    align-items: stretch;
    flex-direction: row;
  }

  .sm\\:card-side :where(figure:first-child){
    overflow: hidden;
    border-start-start-radius: inherit;
    border-start-end-radius: unset;
    border-end-start-radius: inherit;
    border-end-end-radius: unset;
  }

  .sm\\:card-side :where(figure:last-child){
    overflow: hidden;
    border-start-start-radius: unset;
    border-start-end-radius: inherit;
    border-end-start-radius: unset;
    border-end-end-radius: inherit;
  }

  .sm\\:card-side figure > *{
    max-width: unset;
  }

  :where(.sm\\:card-side figure > *){
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
  }

  .sm\\:modal-middle{
    place-items: center;
  }

  .sm\\:card-compact .card-body{
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:card-compact .card-title{
    margin-bottom: 0.25rem;
  }

  .sm\\:card-normal .card-body{
    padding: var(--padding-card, 2rem);
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:card-normal .card-title{
    margin-bottom: 0.75rem;
  }

  .sm\\:modal-middle :where(.modal-box){
    width: 91.666667%;
    max-width: 32rem;
    --tw-translate-y: 0px;
    --tw-scale-x: .9;
    --tw-scale-y: .9;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    border-top-left-radius: var(--rounded-box, 1rem);
    border-top-right-radius: var(--rounded-box, 1rem);
    border-bottom-left-radius: var(--rounded-box, 1rem);
    border-bottom-right-radius: var(--rounded-box, 1rem);
  }
}

@media (min-width: 1024px){

  .md\\:badge-sm{
    height: 1rem;
    font-size: 0.75rem;
    line-height: 1rem;
    padding-left: 0.438rem;
    padding-right: 0.438rem;
  }

  .md\\:btn-md{
    height: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;
    min-height: 3rem;
    font-size: 0.875rem;
  }

  .btn-square:where(.md\\:btn-md){
    height: 3rem;
    width: 3rem;
    padding: 0px;
  }

  .btn-circle:where(.md\\:btn-md){
    height: 3rem;
    width: 3rem;
    border-radius: 9999px;
    padding: 0px;
  }

  .md\\:card-side{
    align-items: stretch;
    flex-direction: row;
  }

  .md\\:card-side :where(figure:first-child){
    overflow: hidden;
    border-start-start-radius: inherit;
    border-start-end-radius: unset;
    border-end-start-radius: inherit;
    border-end-end-radius: unset;
  }

  .md\\:card-side :where(figure:last-child){
    overflow: hidden;
    border-start-start-radius: unset;
    border-start-end-radius: inherit;
    border-end-start-radius: unset;
    border-end-end-radius: inherit;
  }

  .md\\:card-side figure > *{
    max-width: unset;
  }

  :where(.md\\:card-side figure > *){
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
  }

  .md\\:card-compact .card-body{
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:card-compact .card-title{
    margin-bottom: 0.25rem;
  }

  .md\\:card-normal .card-body{
    padding: var(--padding-card, 2rem);
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:card-normal .card-title{
    margin-bottom: 0.75rem;
  }
}

@media (min-width: 1366px){

  .lg\\:badge-md{
    height: 1.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-left: 0.563rem;
    padding-right: 0.563rem;
  }

  .lg\\:btn-lg{
    height: 4rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    min-height: 4rem;
    font-size: 1.125rem;
  }

  .btn-square:where(.lg\\:btn-lg){
    height: 4rem;
    width: 4rem;
    padding: 0px;
  }

  .btn-circle:where(.lg\\:btn-lg){
    height: 4rem;
    width: 4rem;
    border-radius: 9999px;
    padding: 0px;
  }

  .lg\\:card-side{
    align-items: stretch;
    flex-direction: row;
  }

  .lg\\:card-side :where(figure:first-child){
    overflow: hidden;
    border-start-start-radius: inherit;
    border-start-end-radius: unset;
    border-end-start-radius: inherit;
    border-end-end-radius: unset;
  }

  .lg\\:card-side :where(figure:last-child){
    overflow: hidden;
    border-start-start-radius: unset;
    border-start-end-radius: inherit;
    border-end-start-radius: unset;
    border-end-end-radius: inherit;
  }

  .lg\\:card-side figure > *{
    max-width: unset;
  }

  :where(.lg\\:card-side figure > *){
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
  }

  .lg\\:divider-horizontal{
    flex-direction: column;
  }

  .lg\\:divider-horizontal:before{
    height: 100%;
    width: 0.125rem;
  }

  .lg\\:divider-horizontal:after{
    height: 100%;
    width: 0.125rem;
  }

  .lg\\:join-horizontal.join{
    flex-direction: row;
  }

  .lg\\:join-horizontal.join .join-item:first-child:not(:last-child),.lg\\:join-horizontal
  .join *:first-child:not(:last-child) .join-item{
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: inherit;
    border-top-left-radius: inherit;
  }

  .lg\\:join-horizontal.join .join-item:last-child:not(:first-child),.lg\\:join-horizontal
  .join *:last-child:not(:first-child) .join-item{
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: inherit;
    border-top-right-radius: inherit;
  }

  .lg\\:menu-horizontal{
    display: inline-flex;
    flex-direction: row;
  }

  .lg\\:menu-horizontal > li:not(.menu-title) > details > ul{
    position: absolute;
  }

  .lg\\:card-compact .card-body{
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:card-compact .card-title{
    margin-bottom: 0.25rem;
  }

  .lg\\:card-normal .card-body{
    padding: var(--padding-card, 2rem);
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:card-normal .card-title{
    margin-bottom: 0.75rem;
  }

  .lg\\:divider-horizontal{
    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 0px;
    margin-bottom: 0px;
    height: auto;
    width: 1rem;
  }

  .lg\\:join-horizontal.join > :where(*:not(:first-child)){
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: -1px;
  }

  .lg\\:menu-horizontal > li:not(.menu-title) > details > ul{
    margin-left: 0px;
    margin-top: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:menu-horizontal > li > details > ul:before{
    content: none;
  }

  :where(.lg\\:menu-horizontal > li:not(.menu-title) > details > ul){
    --tw-bg-opacity: 1;
    background-color: hsl(var(--b1) / var(--tw-bg-opacity));
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    border-radius: var(--rounded-box, 1rem);
  }
}

@media (min-width: 1536px){

  .xl\\:badge-lg{
    height: 1.5rem;
    font-size: 1rem;
    line-height: 1.5rem;
    padding-left: 0.688rem;
    padding-right: 0.688rem;
  }
}

.placeholder\\:font-lato::-moz-placeholder{
  font-family: Roboto;
}

.placeholder\\:font-lato::placeholder{
  font-family: Roboto;
}

.placeholder\\:text-base::-moz-placeholder{
  font-size: 1rem;
}

.placeholder\\:text-base::placeholder{
  font-size: 1rem;
}

.placeholder\\:text-sm::-moz-placeholder{
  font-size: 0.875rem;
}

.placeholder\\:text-sm::placeholder{
  font-size: 0.875rem;
}

.placeholder\\:text-xs::-moz-placeholder{
  font-size: 0.75rem;
}

.placeholder\\:text-xs::placeholder{
  font-size: 0.75rem;
}

.placeholder\\:text-independenceBlue::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
}

.placeholder\\:text-independenceBlue::placeholder{
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
}

.placeholder\\:text-quickSilver::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(159 159 159 / var(--tw-text-opacity));
}

.placeholder\\:text-quickSilver::placeholder{
  --tw-text-opacity: 1;
  color: rgb(159 159 159 / var(--tw-text-opacity));
}

.hover\\:border-b-4:hover{
  border-bottom-width: 4px;
}

.hover\\:border-spaceCadetBlue:hover{
  --tw-border-opacity: 1;
  border-color: rgb(25 42 81 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#F0FDFF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 255 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#F2F2F3\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 243 / var(--tw-bg-opacity));
}

.hover\\:bg-aliceBlue:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 255 / var(--tw-bg-opacity));
}

.hover\\:bg-begoniaRed:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 113 113 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}

.hover\\:bg-brightGray:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity));
}

.hover\\:bg-coralRed:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 63 63 / var(--tw-bg-opacity));
}

.hover\\:bg-culturedGray:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}

.hover\\:bg-green-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}

.hover\\:bg-independenceBlue:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 116 / var(--tw-bg-opacity));
}

.hover\\:bg-spaceCadetBlue:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
}

.hover\\:bg-statusRed:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(231 49 71 / var(--tw-bg-opacity));
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:text-\\[\\#52b7c9\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(82 183 201 / var(--tw-text-opacity));
}

.hover\\:text-blue-dark:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
}

.hover\\:text-spaceCadetBlue80:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-25:hover{
  opacity: 0.25;
}

.hover\\:opacity-50:hover{
  opacity: 0.5;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:drop-shadow-lg:hover{
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:drop-shadow-md:hover{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:border-\\[\\#2684ff\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(38 132 255 / var(--tw-border-opacity));
}

.focus\\:border-\\[\\#D9DEE8\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(217 222 232 / var(--tw-border-opacity));
}

.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.focus\\:border-green-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}

.focus\\:border-green-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-offset-0:focus{
  outline-offset: 0px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[1px\\]:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-green-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

:is(.dark .dark\\:border-gray-600){
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}

:is(.dark .dark\\:bg-gray-700){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:text-gray-400){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

:is(.dark .dark\\:hover\\:border-gray-500:hover){
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

:is(.dark .dark\\:hover\\:bg-gray-600:hover){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

@media (min-width: 375px){

  .xs\\:mt-2{
    margin-top: 0.5rem;
  }

  .xs\\:mt-3{
    margin-top: 0.75rem;
  }

  .xs\\:w-20{
    width: 5rem;
  }

  .xs\\:w-auto{
    width: auto;
  }

  .xs\\:w-screen{
    width: 100vw;
  }

  .xs\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xs\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xs\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xs\\:flex-row{
    flex-direction: row;
  }

  .xs\\:flex-col{
    flex-direction: column;
  }

  .xs\\:flex-wrap{
    flex-wrap: wrap;
  }

  .xs\\:gap-1{
    gap: 0.25rem;
  }

  .xs\\:text-sm{
    font-size: 0.875rem;
  }

  .xs\\:text-xss{
    font-size: 0.6rem;
  }
}

@media (min-width: 425px){

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:mb-0{
    margin-bottom: 0px;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:ml-2{
    margin-left: 0.5rem;
  }

  .sm\\:ml-36{
    margin-left: 9rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:w-1\\/2{
    width: 50%;
  }

  .sm\\:w-fit{
    width: -moz-fit-content;
    width: fit-content;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:gap-y-1{
    row-gap: 0.25rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
  }

  .sm\\:placeholder\\:text-sm::-moz-placeholder{
    font-size: 0.875rem;
  }

  .sm\\:placeholder\\:text-sm::placeholder{
    font-size: 0.875rem;
  }
}

@media (min-width: 640px){

  .srg\\:mt-0{
    margin-top: 0px;
  }

  .srg\\:w-auto{
    width: auto;
  }

  .srg\\:text-xl{
    font-size: 1.25rem;
  }
}

@media (min-width: 768px){

  .rg\\:mb-0{
    margin-bottom: 0px;
  }

  .rg\\:block{
    display: block;
  }

  .rg\\:flex{
    display: flex;
  }

  .rg\\:w-1\\/4{
    width: 25%;
  }

  .rg\\:w-80{
    width: 20rem;
  }

  .rg\\:w-\\[400px\\]{
    width: 400px;
  }

  .rg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .rg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .rg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .rg\\:text-base{
    font-size: 1rem;
  }

  .rg\\:text-lg{
    font-size: 1.125rem;
  }
}

@media (min-width: 1024px){

  .md\\:inset-0{
    inset: 0px;
  }

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .md\\:m-4{
    margin: 1rem;
  }

  .md\\:mb-0{
    margin-bottom: 0px;
  }

  .md\\:mb-4{
    margin-bottom: 1rem;
  }

  .md\\:mr-4{
    margin-right: 1rem;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:w-48{
    width: 12rem;
  }

  .md\\:w-5\\/6{
    width: 83.333333%;
  }

  .md\\:w-\\[140px\\]{
    width: 140px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }
}

@media (min-width: 1366px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:mb-0{
    margin-bottom: 0px;
  }

  .lg\\:mr-4{
    margin-right: 1rem;
  }

  .lg\\:w-3\\/4{
    width: 75%;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:max-w-lg{
    max-width: 32rem;
  }

  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .lg\\:text-base{
    font-size: 1rem;
  }

  .lg\\:text-xs{
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":"AAKA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;EAAA,0DAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,uBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,0BAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,eAAc;EAAd,cAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,qBAAoB;EAApB,SAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB,uCAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,sBAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB,oBAAoB;KAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,WAAoB;EAApB,SAAoB;EAApB,UAAoB;EAApB,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,6BAAoB;EAApB,2CAAoB;EAApB,YAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,aAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;;;IAAA,kBAAoB;IAApB,sDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;;IAAA,kBAAoB;IAApB;EAAoB;;EAApB;;IAAA,kBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,yBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,yCAAoB;EAApB,YAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,0BAAoB;EAApB,oCAAoB;EAApB,0DAAoB;EAApB,+CAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;KAApB,qBAAoB;UAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,WAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB;AAAoB;AAApB;;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,kCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,eAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,aAAoB;EAApB;AAAoB;AAApB;;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,oBAAoB;KAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,aAAoB;EAApB,UAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,wBAAoB;OAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,cAAoB;EAApB,uCAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,cAAoB;EAApB,yBAAoB;EAApB,WAAoB;EAApB,0BAAoB;UAApB,kBAAoB;EAApB,8BAAoB;UAApB,sBAAoB;EAApB,6BAAoB;UAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,6BAAoB;EAApB,6BAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,0BAAoB;EAApB,mCAAoB;KAApB,gCAAoB;UAApB,2BAAoB;EAApB,4BAAoB;EAApB,kEAAoB;EAApB,mCAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,eAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,gBAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;;;;EAAA,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,eAAoB;EAApB,2BAAoB;EAApB;kCAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;;;;EAAA,mBAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,8fAAoB;EAApB,gBAAoB;EAApB,8BAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;EAAA,WAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,mCAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,eAAoB;EAApB,SAAoB;EAApB,QAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,WAAoB;EAApB,gDAAoB;EAApB,6CAAoB;EAApB,uBAAoB;EAApB,oBAAoB;EAApB,gBAAoB;EAApB,4BAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,QAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,6BAAoB;EAApB,+FAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,WAAoB;EAApB,UAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,UAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,+LAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB,QAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,UAAoB;EAApB,QAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,SAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,SAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,mBAAoB;IAApB;EAAoB;;EAApB;;IAAA,oBAAoB;IAApB,sBAAoB;IAApB,sDAAoB;IAApB,oBAAoB;IAApB,8CAAoB;IAApB;EAAoB;;EAApB;IAAA,+BAAoB;IAApB,iCAAoB;IAApB,iEAAoB;IAApB,+BAAoB;IAApB,yDAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB;EAAoB;;EAApB;IAAA,yBAAoB;IAApB,6BAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB;EAAoB;;EAApB;;;IAAA,sBAAoB;IAApB,sDAAoB;IAApB,oBAAoB;IAApB,8CAAoB;IAApB;EAAoB;;EAApB;IAAA,sBAAoB;IAApB,uDAAoB;IAApB,kBAAoB;IAApB;EAAoB;;EAApB;IAAA,eAAoB;IAApB,eAAoB;IAApB;EAAoB;;EAApB;IAAA,eAAoB;IAApB,sCAAoB;IAApB,oBAAoB;IAApB,8CAAoB;IAApB,8BAAoB;IAApB;EAAoB;;EAApB;;IAAA,mBAAoB;IAApB,8CAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,YAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,gBAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,gBAAoB;EAApB,yBAAoB;EAApB,+CAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB,0BAAoB;EAApB,oCAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;OAApB,gBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,mBAAoB;EAApB,8BAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,iBAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,aAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,gBAAoB;EAApB,SAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,kBAAoB;EAApB,+LAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,YAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kDAAoB;EAApB,0BAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,mDAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kDAAoB;EAApB,mDAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,0BAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,wBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB,wBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,gCAAoB;EAApB;AAAoB;AAApB;;EAAA,gCAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,gCAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,yCAAoB;EAApB,wBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,0BAAoB;UAApB,kBAAoB;EAApB,8BAAoB;UAApB,sBAAoB;EAApB,6BAAoB;UAApB;AAAoB;AAApB;EAAA,uBAAoB;UAApB,eAAoB;EAApB,2BAAoB;UAApB;AAAoB;AAApB;EAAA,uBAAoB;UAApB,eAAoB;EAApB,4BAAoB;UAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;;EAAA,aAAoB;EAApB,sBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB,6DAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB,oCAAoB;KAApB,iCAAoB;UAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,eAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,qBAAoB;EAApB,YAAoB;EAApB,UAAoB;EAApB,4BAAoB;EAApB,YAAoB;EAApB,6BAAoB;EAApB,cAAoB;EAApB,0BAAoB;EAApB,sDAAoB;EAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,+LAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,eAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,gDAAoB;EAApB,iDAAoB;EAApB,mDAAoB;EAApB,oDAAoB;EAApB,mDAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;;;;EAAA,oBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,WAAoB;EAApB,UAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,sCAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,UAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,gBAAoB;EAApB,cAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,qBAAoB;EAApB,6BAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,UAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;OAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;UAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;UAApB,gBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB;;iEAAoB;EAApB;;;;GAAoB;EAApB;;;;;AAAoB;AAApB;EAAA,uCAAoB;EAApB,6FAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,eAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,qBAAoB;OAApB,gBAAoB;EAApB,wBAAoB;EAApB,uBAAoB;EAApB,gBAAoB;EAApB,6BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB,4DAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,eAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,YAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,yCAAoB;EAApB;8DAAoB;EAApB;uCAAoB;EAApB;WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,iBAAoB;EAApB,qCAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,qCAAoB;EAApB,UAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB,UAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,WAAoB;EAApB,qCAAoB;EAApB,qBAAoB;OAApB,gBAAoB;EAApB,uDAAoB;EAApB,wBAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,yBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,2BAAoB;EAApB,6CAAoB;EAApB,4BAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;KAApB,qBAAoB;UAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,eAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kDAAoB;EAApB,4DAAoB;EAApB,uBAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,QAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,WAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,SAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,aAAoB;EAApB,2BAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,uBAAoB;EAApB,sBAAoB;EAApB,wDAAoB;EAApB,yBAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,iBAAoB;EAApB,uDAAoB;EAApB,wBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,2CAAoB;EAApB;oDAAoB;EAApB;;;AAAoB;AAApB;EAAA,kCAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,kCAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,kCAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,kCAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,wBAAoB;EAApB,6BAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,oBAAoB;EAApB,sBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,iCAAoB;EAApB,iEAAoB;EAApB,+BAAoB;EAApB,yDAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,mBAAoB;EAApB,qBAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,+LAAoB;EAApB,YAAoB;EAApB,qBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;EAAA,iCAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,+CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,8BAAoB;EAApB,uGAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,yBAAoB;EAApB,6BAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,8BAAoB;EAApB,uGAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,6BAAoB;EAApB,oBAAoB;EAApB,6CAAoB;EAApB,+BAAoB;EAApB,sBAAoB;EAApB,8BAAoB;EAApB,uGAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,6BAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,6BAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB,sBAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,kCAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,6BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,6BAAoB;EAApB,kEAAoB;EAApB,uCAAoB;EAApB,qEAAoB;EAApB;;;;;;;;;;;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,4BAAoB;EAApB,0DAAoB;EAApB;;;;;;;;;;;AAAoB;AAApB;;;EAAA,6BAAoB;EAApB,kEAAoB;EAApB,uCAAoB;EAApB,qEAAoB;EAApB;;;;;;;;;;;AAAoB;AAApB;EAAA,6BAAoB;EAApB,kEAAoB;EAApB,uCAAoB;EAApB,qEAAoB;EAApB;;;;;;;;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,4BAAoB;EAApB,0DAAoB;EAApB;;;;;;;;;AAAoB;AAApB;EAAA,iBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB,oCAAoB;EAApB,6BAAoB;EAApB,kEAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;;;EAAA;;;;;;;;;;;AAAoB;AAApB;;;EAAA;;;;;;;;;;;AAAoB;AAApB;;;EAAA;;;;;;;;;;;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,+LAAoB;EAApB,wBAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,yBAAoB;EAApB,QAAoB;EAApB,aAAoB;EAApB,WAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,wBAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,WAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;;EAAA,WAAoB;EAApB,aAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;;EAAA,oBAAoB;EAApB;;AAAoB;AAApB;;;;;EAAA,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;;;;EAAA;AAAoB;AAApB;;;;;EAAA;AAAoB;AAApB;EAAA,uDAAoB;EAApB;AAAoB;AAApB;EAAA,uDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;;EAAA,eAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,yBAAoB;EAApB,6BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,qDAAoB;EAApB;AAAoB;AAApB;;EAAA,qDAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,gBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,oBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,qDAAoB;EAApB;AAAoB;AAApB;;;EAAA,qDAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB,wBAAoB;EAApB,yCAAoB;EAApB,kCAAoB;UAApB,0BAAoB;EAApB,yCAAoB;UAApB,iCAAoB;EAApB,wCAAoB;UAApB,gCAAoB;EAApB,sEAAoB;UAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,aAAoB;EAApB,8BAAoB;EAApB,uBAAoB;UAApB,eAAoB;EAApB,8BAAoB;UAApB,sBAAoB;EAApB,6BAAoB;UAApB,qBAAoB;EAApB,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,2DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,4DAAoB;UAApB;AAAoB;AAApB;EAAA,sCAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,eAAoB;EAApB,SAAoB;EAApB,YAAoB;EAApB,UAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,yCAAoB;EAApB;AAAoB;AAApB;;;;;;EAAA,eAAoB;EAApB,sCAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,iBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,wBAAoB;EAApB,0CAAoB;EAApB,yBAAoB;EAApB,wDAAoB;EAApB,WAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,yBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,mBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,YAAoB;EAApB;;;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,mBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,qBAAoB;EAApB,YAAoB;EAApB;;;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB,gBAAoB;EAApB,YAAoB;EAApB,YAAoB;EAApB,cAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,oBAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,qBAAoB;EAApB,YAAoB;EAApB;;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,YAAoB;EAApB,QAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,+LAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,aAAoB;EAApB,QAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,+LAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,oCAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,mBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;;;;EAAA,qBAAoB;EAApB,eAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB;;;;;;GAAoB;EAApB,qBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,6BAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB;;;;;;GAAoB;EAApB,qBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,0DAAoB;EAApB;;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;;EAAoB;;EAApB;IAAA;;EAAoB;;EAApB;IAAA;;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,uCAAoB;EAApB,gBAAoB;EAApB,wBAAoB;EAApB,QAAoB;EAApB,6BAAoB;EAApB,2BAAoB;EAApB,qBAAoB;EAApB,uBAAoB;EAApB;;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,uCAAoB;EAApB,QAAoB;EAApB,6BAAoB;EAApB,qBAAoB;EAApB,uBAAoB;EAApB;;;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;OAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,8BAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,qDAAoB;EAApB;AAAoB;AAApB;;;EAAA,qDAAoB;EAApB;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;;AAAoB;AAApB;EAAA,wBAAoB;EAApB,0DAAoB;EAApB,mEAAoB;EAApB,wBAAoB;EAApB,kEAAoB;EAApB;AAAoB;AAApB;EAAA,QAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB,+LAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB;AAAoB;AAApB;;;EAAA,0BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;;;EAAA,2BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA,uDAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,qDAAoB;EAApB;AAAoB;AAApB;;EAAA,mBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,uDAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,gDAAoB;EAApB,0CAAoB;EAApB,iDAAoB;EAApB,kDAAoB;EAApB,4CAAoB;EAApB,sCAAoB;EAApB,uCAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,oFAAoB;EAApB,0CAAoB;EAApB,2CAAoB;EAApB,yCAAoB;EAApB,qEAAoB;EAApB,sEAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;;EAAA,UAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,gCAAoB;EAApB,iCAAoB;EAApB,SAAoB;EAApB,8CAAoB;EAApB;;;;;;;AAAoB;AAApB;EAAA,0CAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,2CAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,wBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB;AAAoB;AAApB;EAAA,qDAAoB;EAApB;AAAoB;AAApB;;;EAAA,qDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA,qBAAoB;IAApB;EAAoB;;EAApB;IAAA,mBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,6CAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,kBAAoB;EAApB;;;AAAoB;AAApB;EAAA;;;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,sDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,uDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,uDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,uDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,uDAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,6BAAoB;EAApB,YAAoB;EAApB;;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qCAAoB;EAApB,mCAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,mCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,iCAAoB;EAApB,8CAAoB;EAApB,yCAAoB;EAApB,+BAAoB;EAApB,mCAAoB;EAApB,gCAAoB;EAApB,2CAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,gDAAoB;EAApB;AAAoB;AAApB;EAAA,mDAAoB;EAApB;AAAoB;AAApB;EAAA,gDAAoB;EAApB;AAAoB;AAApB;EAAA,iDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,YAAoB;EAApB,sDAAoB;UAApB,8CAAoB;EAApB,6BAAoB;EAApB;;;;;;;;;OAAoB;EAApB;+BAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,YAAoB;IAApB,sDAAoB;YAApB,8CAAoB;IAApB,6BAAoB;IAApB;;;;;;;;;SAAoB;IAApB;iCAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,UAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,aAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,aAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kCAAoB;EAApB,8BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,gCAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,YAAoB;EAApB,oBAAoB;KAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,UAAoB;EAApB,UAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,WAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,UAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,UAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,SAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,4BAAoB;EAApB,6BAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;;EAAA,yBAAoB;EAApB,0BAAoB;EAApB,kCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,6BAAoB;EAApB,0BAAoB;EAApB,kCAAoB;EAApB;AAAoB;AAApB;;EAAA,4BAAoB;EAApB,yBAAoB;EAApB,mCAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,aAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,aAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,oBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,oBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,oBAAoB;EAApB,sBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,6CAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,UAAoB;EAApB,UAAoB;EAApB,SAAoB;EAApB,qBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,SAAoB;EAApB,UAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,UAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,SAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,QAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,UAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,SAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,0BAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,QAAoB;EAApB,UAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,QAAoB;EAApB,2BAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,8CAAoB;EAApB,uCAAoB;EAApB;;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,iCAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,OAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,iCAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,OAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,0BAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,gBAAoB;EAApB,kDAAoB;EAApB,0BAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,mDAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,0BAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,gBAAoB;EAApB,kDAAoB;EAApB,0BAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,mDAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,gBAAoB;EAApB,kDAAoB;EAApB,mDAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,0BAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kCAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,gFAAoB;EAApB,oGAAoB;EAApB,uGAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,yBAAoB;EAApB,eAAoB;EAApB,eAAoB;EAApB,+LAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,gBAAoB;EAApB,qBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,+LAAoB;EAApB,gDAAoB;EAApB,iDAAoB;EAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;EAApB,eAAoB;EAApB,eAAoB;EAApB,+LAAoB;EAApB,+BAAoB;EAApB,8BAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,0DAAoB;EAApB,mEAAoB;EAApB,wBAAoB;EAApB,kEAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,0DAAoB;EAApB,mEAAoB;EAApB,wBAAoB;EAApB,kEAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,4BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB,qBAAoB;EAApB,+LAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,+BAAoB;EAApB,wBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,+LAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,yBAAoB;EAApB,8BAAoB;EAApB,oCAAoB;EAApB;AAAoB;AAApB;;EAAA,UAAoB;EAApB,gKAAoB;EAApB,wJAAoB;EAApB,iLAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,oCAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,sBAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,sCAAoB;EAApB,gCAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;;;;EAAA,UAAoB;EAApB;AAAoB;AAApB;;EAAA,UAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,sEAAoB;EAApB,SAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,sEAAoB;EAApB,+BAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,sEAAoB;EAApB,QAAoB;EAApB,UAAoB;EAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,sEAAoB;EAApB,QAAoB;EAApB,kDAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,WAAmB;EAAnB,YAAmB;EAAnB,UAAmB;EAAnB,SAAmB;EAAnB,iBAAmB;EAAnB,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAZA;;EAAA;;IAAA,kBAaA;IAbA;EAaA;;EAbA;;IAAA,kBAaA;IAbA;EAaA;AAAA;;AAbA;;EAAA;IAAA,oBAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,kCAaA;IAbA,8BAaA;IAbA,gCAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,gCAaA;IAbA,gCAaA;IAbA,8BAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,WAaA;IAbA,YAaA;IAbA,oBAaA;OAbA;EAaA;;EAbA;IAAA,aAaA;IAbA,mBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,kCAaA;IAbA,eAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA,YAaA;IAbA,qBAaA;IAbA,sBAaA;IAbA,gBAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,WAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,WAaA;IAbA,qBAaA;IAbA;EAaA;;EAbA;IAAA,oBAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,kCAaA;IAbA,8BAaA;IAbA,gCAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,gCAaA;IAbA,gCAaA;IAbA,8BAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,WAaA;IAbA,YAaA;IAbA,oBAaA;OAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,aAaA;IAbA,mBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,kCAaA;IAbA,eAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,iBAaA;IAbA,gBAaA;IAbA,qBAaA;IAbA,gBAaA;IAbA,gBAaA;IAbA,+LAaA;IAbA,gDAaA;IAbA,iDAaA;IAbA,mDAaA;IAbA;EAaA;AAAA;;AAbA;;EAAA;IAAA,YAaA;IAbA,kBAaA;IAbA,iBAaA;IAbA,sBAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,kBAaA;IAbA,mBAaA;IAbA,gBAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,WAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,WAaA;IAbA,qBAaA;IAbA;EAaA;;EAbA;IAAA,oBAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,kCAaA;IAbA,8BAaA;IAbA,gCAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,gCAaA;IAbA,gCAaA;IAbA,8BAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,WAaA;IAbA,YAaA;IAbA,oBAaA;OAbA;EAaA;;EAbA;IAAA,aAaA;IAbA,mBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,kCAaA;IAbA,eAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA,eAaA;IAbA,mBAaA;IAbA,oBAaA;IAbA,sBAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,oBAaA;IAbA,qBAaA;IAbA,gBAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,WAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA,WAaA;IAbA,qBAaA;IAbA;EAaA;;EAbA;IAAA,oBAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,kCAaA;IAbA,8BAaA;IAbA,gCAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,gCAaA;IAbA,gCAaA;IAbA,8BAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,WAaA;IAbA,YAaA;IAbA,oBAaA;OAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,YAaA;IAbA;EAaA;;EAbA;IAAA,YAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;;IAAA,6BAaA;IAbA,0BAaA;IAbA,kCAaA;IAbA;EAaA;;EAbA;;IAAA,4BAaA;IAbA,yBAaA;IAbA,mCAaA;IAbA;EAaA;;EAbA;IAAA,oBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,aAaA;IAbA,mBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,kCAaA;IAbA,eAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,iBAaA;IAbA,kBAaA;IAbA,eAaA;IAbA,kBAaA;IAbA,YAaA;IAbA;EAaA;;EAbA;IAAA,eAaA;IAbA,kBAaA;IAbA;EAaA;;EAbA;IAAA,gBAaA;IAbA,gBAaA;IAbA,mBAaA;IAbA,sBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,kBAaA;IAbA,uDAaA;IAbA,gFAaA;IAbA,oGAaA;IAbA,uGAaA;IAbA;EAaA;AAAA;;AAbA;;EAAA;IAAA,cAaA;IAbA,eAaA;IAbA,mBAaA;IAbA,sBAaA;IAbA;EAaA;AAAA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA,6EAaA;EAbA,iGAaA;EAbA;AAaA;;AAbA;EAAA,gFAaA;EAbA,oGAaA;EAbA;AAaA;;AAbA;EAAA,mGAaA;EAbA;AAaA;;AAbA;EAAA,mGAaA;EAbA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,8BAaA;EAbA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA,2GAaA;EAbA,yGAaA;EAbA;AAaA;;AAbA;EAAA,2GAaA;EAbA,yGAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;EAAA,oBAaA;EAbA;AAaA;;AAbA;EAAA,sBAaA;EAbA;AAaA;;AAbA;EAAA,kBAaA;EAbA;AAaA;;AAbA;;EAAA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA,uBAaA;IAbA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;AAAA;;AAbA;;EAAA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;;EAbA;IAAA;EAaA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=PT+Sans+Caption:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=PT+Sans+Caption:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Work+Sans:400,700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.page-private_layouts__container {\n  display: grid;\n  grid-template-columns: 20% 80%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
